import { jsx as u, jsxs as C, Fragment as rt } from "react/jsx-runtime";
import { createContext as Ot, useContext as Pt, useMemo as R, useCallback as N, useRef as U, useEffect as Y, useState as L, lazy as Dt, memo as it, Suspense as Be, startTransition as In, Fragment as On } from "react";
import { DeleteOutlined as Rt, LinkOutlined as Pn, PlusOutlined as Dn, DownloadOutlined as Rn, SaveOutlined as Et, CloseCircleOutlined as Vt, EyeOutlined as En, InboxOutlined as Vn, EditOutlined as $n } from "@ant-design/icons";
import { useQueryClient as Mn } from "@tanstack/react-query";
import { Flex as Q, List as Ft, Typography as _e, Alert as Ye, Radio as _t, DatePicker as $t, TimePicker as Bn, Modal as Mt, Button as pe, Image as Bt, Empty as je, Card as jt, Spin as Oe, Input as ot, Rate as jn, Select as Ln, Tag as Lt, Slider as Un, Table as He, Divider as xn, message as Ie } from "antd";
import { b as Je, u as Hn, a as Cn } from "./use-definition-0yWcQDPI.js";
import { y as Ut, p as xt, z, n as Ht, d as re, c as ie, i as zn, h as Kn, m as qn, u as Ct, q as Pe } from "./fetcher-CUYp7JR1.js";
import { u as Le, c as Yn, l as Jn, e as Zn, n as Wn, o as wt, s as Gn, i as Qn, r as Xn } from "./templateResolver-BchYA4i9.js";
import "@mantine/core/styles.css";
import { PreviewText as er, Input as tr, Reset as zt, Submit as Kt, Upload as nr, Password as rr, TimePicker as ir, TreeSelect as or, Cascader as sr, Radio as ar, Checkbox as cr, NumberPicker as lr, Switch as ur, Select as dr, DatePicker as fr, FormLayout as mr, FormGrid as yr, FormItem as gr, Form as hr, ArrayTable as ve } from "@formily/antd-v5";
import { isField as qt, createForm as br, onFieldValueChange as Sr, onFieldInit as Fr, onFormValuesChange as _r, onFormUnmount as wr } from "@formily/core";
import { connect as ae, mapProps as le, mapReadPretty as de, useField as Ue, useForm as st, observer as at, RecursionField as Ar, useFieldSchema as vr, createSchemaField as pr, FormProvider as Tr } from "@formily/react";
import { Tabs as Ve, Loader as At, Center as kr, Badge as Nr, MantineProvider as Ir } from "@mantine/core";
import J from "dayjs";
import Or from "dayjs/plugin/customParseFormat";
import "idb";
import { o as Pr, i as Dr, D as Yt } from "./DataGrid-Cy1qOpyR.js";
import { registerPlugin as Rr, FilePond as Er } from "react-filepond";
import Vr from "filepond-plugin-file-validate-type";
import $r from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";
import { JsonEditor as Jt } from "json-edit-react";
import { MaskedInput as Mr } from "antd-mask-input";
import Br from "dayjs/plugin/utc";
function jr(e) {
  if (!e) return "";
  const t = ": ", n = e.indexOf(t);
  return n === -1 ? e : e.slice(n + t.length);
}
function Lr(e) {
  try {
    const t = JSON.parse(e);
    if (t && typeof t == "object" && "errors" in t && Array.isArray(t.errors)) {
      const { errors: n } = t, r = n.map((i) => i == null ? void 0 : i.developerMessage).filter((i) => !!(i != null && i.trim()));
      if (r.length > 0)
        return r.join(" ");
    }
  } catch {
  }
  return null;
}
function Ur(e, t) {
  if (!e || typeof e != "object")
    return t;
  const n = e, r = jr(n.info), i = Lr(r);
  if (i)
    return i;
  const o = r.trim();
  return o || n.message || t;
}
async function be(e, t) {
  try {
    return await e();
  } catch (n) {
    throw new Error(Ur(n, t));
  }
}
async function pa(e) {
  return be(
    () => re(ie("/auth/forgot-password"), {
      method: "POST",
      body: JSON.stringify({ email: e })
    }),
    "Request failed"
  );
}
async function Ta(e, t) {
  return be(
    () => re(ie("/auth/reset-password"), {
      method: "POST",
      body: JSON.stringify({ token: e, password: t })
    }),
    "Request failed"
  );
}
function xr(e) {
  return "twofa_required" in e && e.twofa_required;
}
async function ka(e) {
  Ut(xt());
  const t = await be(
    () => re(ie("/auth/login"), {
      method: "POST",
      body: JSON.stringify(e)
    }),
    "Login failed"
  );
  return !xr(t) && "token" in t && t.token && (localStorage.setItem("AUTH_TOKEN", t.token), lt(), z.getState().setLoggedIn(!0), Ht(t)), t;
}
async function Na(e, t) {
  return be(
    () => re(ie("/auth/twofa/send"), {
      method: "POST",
      body: JSON.stringify({
        challenge_token: e,
        channel: t
      })
    }),
    "Failed to send verification code"
  );
}
async function Ia(e, t) {
  Ut(xt());
  const n = await be(
    () => re(ie("/auth/twofa/verify"), {
      method: "POST",
      body: JSON.stringify({ challenge_token: e, code: t })
    }),
    "Verification failed"
  );
  return n.token && (localStorage.setItem("AUTH_TOKEN", n.token), lt(), z.getState().setLoggedIn(!0), Ht(n)), n;
}
async function Oa() {
  return be(
    () => re(ie("/auth/twofa/methods")),
    "Failed to fetch 2FA methods"
  );
}
async function Pa(e, t, n) {
  return be(
    () => re(ie("/auth/twofa/enroll"), {
      method: "POST",
      body: JSON.stringify({
        channel: e,
        destination: t,
        country_code: n
      })
    }),
    "Failed to enroll 2FA method"
  );
}
async function Da(e, t) {
  return be(
    () => re(ie("/auth/twofa/confirm"), {
      method: "POST",
      body: JSON.stringify({ method_id: e, code: t })
    }),
    "Failed to confirm enrollment"
  );
}
async function Ra(e) {
  return be(
    () => re(ie("/auth/twofa/enroll"), {
      method: "DELETE",
      body: JSON.stringify({ method_id: e })
    }),
    "Failed to remove 2FA method"
  );
}
function Hr() {
  localStorage.removeItem("AUTH_TOKEN"), z.getState().clearAuth();
}
function Ea() {
  return !!localStorage.getItem("AUTH_TOKEN");
}
function ct() {
  return localStorage.getItem("AUTH_TOKEN");
}
function lt() {
  const e = ct();
  if (!e) {
    z.getState().setIsSuperAdmin(!1);
    return;
  }
  const t = Zt(e);
  z.getState().setIsSuperAdmin(!!(t != null && t.isSuperAdmin));
}
function Zt(e) {
  try {
    const t = e.split(".");
    if (t.length !== 3 || !t[1]) return null;
    const n = t[1].replace(/-/g, "+").replace(/_/g, "/"), r = atob(n);
    return JSON.parse(r);
  } catch {
    return null;
  }
}
async function Va() {
  if (!ct())
    return z.getState().setIsSuperAdmin(!1), !1;
  try {
    const t = await re(ie("/auth/refresh"), {
      method: "PUT"
    });
    return t && typeof t == "object" && "token" in t && t.token && localStorage.setItem("AUTH_TOKEN", String(t.token)), lt(), !0;
  } catch {
    return Hr(), !1;
  }
}
function Cr(e, t, n) {
  if (!e) return !1;
  const r = e[t];
  if (!r) return !1;
  const i = `:${n}`;
  return Object.keys(r).some((o) => o.endsWith(i));
}
function Ze(e, t, n, r, i) {
  if (i) return !0;
  if (!e) return !1;
  const o = e[t];
  return o ? !!o[`${n}:${r}`] : !1;
}
function Ee(e) {
  return e.isSuperAdmin ? !0 : e.permissions ? Cr(
    e.permissions,
    e.entityName,
    e.operation
  ) : !1;
}
function Wt(e) {
  return Ee({
    ...e,
    operation: "change"
  });
}
function Gt(e) {
  return Ee({
    ...e,
    operation: "create"
  });
}
function zr(e) {
  return Ee({
    ...e,
    operation: "remove"
  });
}
function Kr(e) {
  return Ee({
    ...e,
    operation: "read"
  });
}
function qr(e) {
  return e.isSuperAdmin ? !0 : Ze(
    e.permissions,
    e.entityName,
    e.fieldName,
    "read",
    e.isSuperAdmin
  );
}
function Yr(e) {
  const { isSuperAdmin: t, permissions: n, entityName: r, fieldName: i, formMode: o } = e;
  return o === "create" ? t || Ze(
    n,
    r,
    i,
    "create",
    t
  ) ? "editable" : "readOnly" : o === "edit" ? t || Ze(
    n,
    r,
    i,
    "change",
    t
  ) ? "editable" : "readOnly" : "readPretty";
}
function Jr(e) {
  const { isSuperAdmin: t, permissions: n, entityName: r, requestedMode: i } = e;
  return t ? i : i === "create" ? Gt({ isSuperAdmin: t, permissions: n, entityName: r }) ? "create" : "read" : i === "edit" ? Wt({ isSuperAdmin: t, permissions: n, entityName: r }) ? "edit" : "read" : i;
}
function Me(e) {
  return e.replace(/^\/+|\/+$/g, "");
}
function Ce(e) {
  const t = Me(e);
  return t === "" ? "" : `${t}/`;
}
function Qt(e, t) {
  for (const n of Object.keys(t)) {
    const r = Me(n);
    if (r.includes("*")) {
      const o = r.split("*");
      if (o.length === 2) {
        const [a, s] = o, c = s === "" ? Ce(e) : Me(e);
        if (!c.startsWith(a)) continue;
        if (s === "") {
          if (c === a || c.length > a.length)
            return !0;
        } else if (c.endsWith(s) && c.length > a.length + s.length)
          return !0;
      }
      continue;
    }
    if (Ce(n) === Ce(e)) return !0;
    const i = Me(e);
    if (r && i.startsWith(`${r}/`))
      return !0;
  }
  return !1;
}
function Zr(e, t, n) {
  return n ? !0 : !t || Object.keys(t).length === 0 ? !1 : Qt(e, t);
}
function Wr(e, t, n) {
  return n ? !0 : !t || Object.keys(t).length === 0 ? !1 : Qt(e, t);
}
function Gr(e, t, n) {
  if (n) return !0;
  const r = t == null ? void 0 : t.element;
  return r ? !!r[e] : !1;
}
function vt(e) {
  const t = e == null ? "" : typeof e == "string" ? e : typeof e == "number" || typeof e == "boolean" ? String(e) : "";
  return /[",\n\r]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t;
}
function Qr(e, t) {
  const n = t.map((i) => vt(i.title)).join(","), r = e.map(
    (i) => t.map((o) => {
      const a = i[o.key], s = o.render ? o.render(a, i) : a;
      return vt(s);
    }).join(",")
  );
  return [n, ...r].join(`\r
`);
}
function Xr(e, t) {
  const n = new Blob([e], { type: "text/csv;charset=utf-8;" }), r = URL.createObjectURL(n), i = document.createElement("a");
  i.href = r, i.download = t.endsWith(".csv") ? t : `${t}.csv`, i.style.display = "none", document.body.appendChild(i), i.click(), document.body.removeChild(i), URL.revokeObjectURL(r);
}
async function $a(e, t = {}) {
  const n = [], r = t.limit ?? 100;
  let i = t.page ?? 1;
  for (; ; ) {
    const o = await zn(e, {
      ...t,
      page: i,
      limit: r
    }), a = Array.isArray(o.data) ? o.data : [];
    if (n.push(...a), !o.nextPage)
      break;
    i = o.nextPage;
  }
  return n;
}
function ei(e) {
  const t = (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
  return `${e}-${t}.csv`;
}
function fe() {
  const { isSuperAdmin: e, profile: t } = z.getState();
  return !!(e ?? (t == null ? void 0 : t.is_super_admin));
}
function Ma(e) {
  var n;
  const { access: t } = z.getState();
  return Zr(
    e,
    (n = t == null ? void 0 : t.rules) == null ? void 0 : n.uiRoute,
    fe()
  );
}
function Ba(e) {
  var n;
  const { access: t } = z.getState();
  return Wr(
    e,
    (n = t == null ? void 0 : t.rules) == null ? void 0 : n.path,
    fe()
  );
}
function ja(e) {
  const { access: t } = z.getState();
  return Gr(
    e,
    t == null ? void 0 : t.rules,
    fe()
  );
}
function La(e, t) {
  const { access: n } = z.getState();
  return Ee({
    isSuperAdmin: fe(),
    permissions: n == null ? void 0 : n.permissions,
    entityName: e,
    operation: t
  });
}
function Xt(e) {
  const { access: t } = z.getState();
  return Wt({
    isSuperAdmin: fe(),
    permissions: t == null ? void 0 : t.permissions,
    entityName: e
  });
}
function ti(e) {
  const { access: t } = z.getState();
  return Gt({
    isSuperAdmin: fe(),
    permissions: t == null ? void 0 : t.permissions,
    entityName: e
  });
}
function ni(e) {
  const { access: t } = z.getState();
  return zr({
    isSuperAdmin: fe(),
    permissions: t == null ? void 0 : t.permissions,
    entityName: e
  });
}
function Ua(e) {
  const { access: t } = z.getState();
  return Kr({
    isSuperAdmin: fe(),
    permissions: t == null ? void 0 : t.permissions,
    entityName: e
  });
}
function xa(e, t) {
  const { access: n } = z.getState();
  return qr({
    isSuperAdmin: fe(),
    permissions: n == null ? void 0 : n.permissions,
    entityName: e,
    fieldName: t
  });
}
function ri(e, t, n) {
  const { access: r } = z.getState();
  return Yr({
    isSuperAdmin: fe(),
    permissions: r == null ? void 0 : r.permissions,
    entityName: e,
    fieldName: t,
    formMode: n
  });
}
function ii(e, t) {
  const { access: n } = z.getState();
  return Jr({
    isSuperAdmin: fe(),
    permissions: n == null ? void 0 : n.permissions,
    entityName: e,
    requestedMode: t
  });
}
function Ha() {
  var i;
  const e = (i = z.getState().profile) == null ? void 0 : i.id;
  if (typeof e == "number")
    return e;
  const t = ct();
  if (!t)
    return;
  const n = Zt(t), r = n == null ? void 0 : n.userID;
  return typeof r == "number" ? r : void 0;
}
function en() {
  var t;
  const e = (t = z.getState().profile) == null ? void 0 : t.role;
  if (typeof e == "string" && e.length > 0)
    return e;
}
function Ca() {
  return fe() ? !0 : en() === "admin";
}
const oi = Ot(
  null
), si = () => Pt(oi), ai = {
  success: "var(--ant-color-success)",
  info: "var(--ant-color-info)",
  warning: "var(--ant-color-warning)",
  error: "var(--ant-color-error)"
}, ci = ({ alert: e, list: t }) => {
  const n = (e == null ? void 0 : e.type) ?? "info", r = ai[n];
  return /* @__PURE__ */ u(Q, { vertical: !0, gap: "small", children: t.length > 1 ? /* @__PURE__ */ u(
    "div",
    {
      style: {
        borderLeft: `3px solid ${r}`,
        paddingLeft: 12
      },
      children: /* @__PURE__ */ u(
        Ft,
        {
          size: "small",
          dataSource: t,
          renderItem: (i) => /* @__PURE__ */ u(
            Ft.Item,
            {
              style: {
                borderBlockEnd: "none",
                paddingBlock: 2
              },
              children: /* @__PURE__ */ u(_e.Text, { children: i })
            }
          ),
          style: { marginBottom: 0 }
        }
      )
    }
  ) : /* @__PURE__ */ u(
    Ye,
    {
      message: t.length === 1 ? t[0] : e.message,
      type: n,
      showIcon: !0,
      banner: !0
    }
  ) });
};
function li(e) {
  if (!Array.isArray(e) || e.length === 0) return;
  const [t] = e;
  return typeof t == "string" || typeof t == "number" ? e.map((n) => ({
    value: n,
    label: String(n)
  })) : e.map(
    (n) => ({
      value: n.value,
      label: n.label ?? String(n.value)
    })
  );
}
function ui({
  value: e,
  onChange: t,
  disabled: n = !1,
  readOnly: r = !1,
  options: i,
  dataSource: o,
  ...a
}) {
  const s = n || r, c = R(
    () => li(i ?? o),
    [o, i]
  ), f = N(
    (g) => {
      s || e === g && (t == null || t(void 0));
    },
    [s, t, e]
  );
  return /* @__PURE__ */ u(
    _t.Group,
    {
      ...a,
      disabled: s,
      value: e ?? void 0,
      onChange: (g) => t == null ? void 0 : t(g.target.value),
      options: c ? void 0 : i ?? o,
      children: c ? c.map((g) => /* @__PURE__ */ u(
        _t,
        {
          value: g.value,
          onClick: () => {
            f(g.value);
          },
          children: g.label
        },
        String(g.value)
      )) : null
    }
  );
}
const di = ae(
  ui,
  le(
    { dataSource: "options" },
    (e, t) => ({
      ...e,
      disabled: !!e.disabled || t.disabled || t.readOnly || t.pattern === "readPretty",
      readOnly: !!e.readOnly || t.readOnly || t.pattern === "readPretty"
    })
  ),
  de(er.Select)
), fi = ({ value: e }) => {
  if (!e) return /* @__PURE__ */ u("span", { children: "—" });
  const t = J(e);
  return /* @__PURE__ */ u("span", { children: t.isValid() ? t.format("MM/DD/YYYY") : e });
}, mi = ({ value: e }) => {
  if (!e) return /* @__PURE__ */ u("span", { children: "—" });
  const t = J(e);
  return /* @__PURE__ */ u("span", { children: t.isValid() ? t.format("MM/DD/YYYY HH:mm:ss") : e });
};
function yi({ value: e, onChange: t, ...n }) {
  const r = U(t);
  Y(() => {
    r.current = t;
  });
  const i = N(
    (o) => {
      var a;
      return (a = r.current) == null ? void 0 : a.call(r, o ? o.format("YYYY-MM-DD") : null);
    },
    []
  );
  return /* @__PURE__ */ u(
    $t,
    {
      ...n,
      format: "MM/DD/YYYY",
      placeholder: "Select Date...",
      value: e ? J(e) : void 0,
      onChange: i
    }
  );
}
const gi = ae(
  yi,
  le({ readOnly: "readOnly" }),
  de(fi)
);
function hi({ value: e, onChange: t, ...n }) {
  const r = U(t);
  Y(() => {
    r.current = t;
  });
  const i = N(
    (o) => {
      var a;
      return (a = r.current) == null ? void 0 : a.call(
        r,
        o ? o.format("YYYY-MM-DD HH:mm:ss") : null
      );
    },
    []
  );
  return /* @__PURE__ */ u(
    $t,
    {
      ...n,
      showTime: !0,
      format: "MM/DD/YYYY HH:mm:ss",
      placeholder: "Select Date and Time...",
      value: e ? J(e) : void 0,
      onChange: i
    }
  );
}
const bi = ae(
  hi,
  le({ readOnly: "readOnly" }),
  de(mi)
);
J.extend(Or);
const We = "HH:mm";
function Si(e) {
  const t = J(e, [We, "HH:mm:ss"], !0);
  return t.isValid() ? t : null;
}
const Fi = ({
  value: e,
  use12Hours: t = !0
}) => e ? /* @__PURE__ */ u("span", { children: Pr(e, t) }) : /* @__PURE__ */ u("span", { children: "—" });
function _i({
  value: e,
  onChange: t,
  use12Hours: n = !0,
  ...r
}) {
  const i = U(t);
  Y(() => {
    i.current = t;
  });
  const o = n ? "h:mm A" : We, a = N((s) => {
    var c;
    (c = i.current) == null || c.call(i, s ? s.format(We) : void 0);
  }, []);
  return /* @__PURE__ */ u(
    Bn,
    {
      ...r,
      use12Hours: n,
      format: o,
      placeholder: "Select Time...",
      value: e ? Si(e) ?? void 0 : void 0,
      onChange: a,
      needConfirm: !1
    }
  );
}
const wi = ae(
  _i,
  le({ readOnly: "readOnly" }),
  de(Fi)
), Ai = "_confirmBody_s9u6c_1", vi = "_confirmIcon_s9u6c_7", pi = "_confirmCopy_s9u6c_20", Ti = "_confirmTitle_s9u6c_29", ki = "_confirmMessage_s9u6c_37", Ni = "_confirmFileName_s9u6c_45", Ne = {
  confirmBody: Ai,
  confirmIcon: vi,
  confirmCopy: pi,
  confirmTitle: Ti,
  confirmMessage: ki,
  confirmFileName: Ni
}, tn = Er;
Rr($r, Vr);
const Ii = 3200;
function ut() {
  return typeof window < "u" ? window.localStorage.getItem("AUTH_TOKEN") : null;
}
function nn(e) {
  return !!(e != null && e.startsWith("image/"));
}
function Ge(e) {
  return {
    source: String(e.id),
    options: {
      type: "local",
      file: {
        name: e.fileName,
        size: e.fileSize ?? 0,
        type: e.fileType ?? "application/octet-stream"
      }
    }
  };
}
async function rn(e, t) {
  const n = ut(), r = await fetch(`/api/file/download/${e}?hash=${t}`, {
    headers: n ? { Authorization: `Bearer ${n}` } : {}
  });
  if (!r.ok) throw new Error("Failed to load file");
  const i = await r.blob();
  return URL.createObjectURL(i);
}
function Qe(e) {
  return (t, n, r, i, o) => {
    const a = ut(), s = new AbortController();
    return fetch(`/api/file/download/${t}?hash=${e}`, {
      signal: s.signal,
      headers: a ? { Authorization: `Bearer ${a}` } : {}
    }).then((c) => {
      if (!c.ok) throw new Error("Failed to load file");
      return c.blob();
    }).then((c) => {
      n(c);
    }).catch((c) => {
      if (c instanceof DOMException && c.name === "AbortError")
        return;
      const f = c instanceof Error ? c.message : "Network error";
      r(f);
    }), {
      abort: () => {
        s.abort(), o();
      }
    };
  };
}
const Oi = ({ value: e }) => {
  const [t, n] = L(() => e != null && e.id ? [Ge(e)] : []), [r, i] = L(null), o = N(() => {
    !(e != null && e.id) || !(e != null && e.fileHash) || rn(e.id, e.fileHash).then((a) => {
      nn(e.fileType) ? i(a) : window.open(a, "_blank");
    });
  }, [e == null ? void 0 : e.id, e == null ? void 0 : e.fileHash, e == null ? void 0 : e.fileType]);
  return e != null && e.fileName ? /* @__PURE__ */ C(rt, { children: [
    /* @__PURE__ */ u(
      tn,
      {
        files: t,
        onupdatefiles: (a) => {
          n(a);
        },
        onactivatefile: o,
        allowMultiple: !1,
        allowDrop: !1,
        allowBrowse: !1,
        allowPaste: !1,
        allowReplace: !1,
        allowRevert: !1,
        allowRemove: !1,
        allowProcess: !1,
        server: {
          process: null,
          revert: null,
          load: Qe(e.fileHash),
          restore: null,
          fetch: null
        },
        credits: !1,
        labelIdle: ""
      }
    ),
    /* @__PURE__ */ u(
      Bt,
      {
        style: { display: "none" },
        preview: {
          visible: !!r,
          src: r ?? void 0,
          onVisibleChange: (a) => {
            a || (r && URL.revokeObjectURL(r), i(null));
          }
        }
      }
    )
  ] }) : /* @__PURE__ */ u(_e.Text, { type: "secondary", children: "No file" });
}, Pi = ({
  value: e,
  onChange: t,
  maxCount: n = 1,
  disabled: r = !1
}) => {
  var Z, x;
  const i = U(!1), o = U(null), [a, s] = L(!1), [c, f] = L(null), g = N(() => e != null && e.id ? [Ge(e)] : [], [e == null ? void 0 : e.id, e == null ? void 0 : e.fileName, e == null ? void 0 : e.fileSize, e == null ? void 0 : e.fileType]), [h, d] = L(g);
  Y(() => {
    if (i.current) {
      i.current = !1;
      return;
    }
    d(g());
  }, [g]);
  const b = ut(), S = N(() => {
    const I = o.current, K = (I == null ? void 0 : I.id) ?? (e == null ? void 0 : e.id), B = (I == null ? void 0 : I.fileHash) ?? (e == null ? void 0 : e.fileHash), ue = (I == null ? void 0 : I.fileType) ?? (e == null ? void 0 : e.fileType);
    !K || !B || rn(K, B).then((P) => {
      nn(ue) ? f(P) : window.open(P, "_blank");
    });
  }, [e == null ? void 0 : e.id, e == null ? void 0 : e.fileHash, e == null ? void 0 : e.fileType]), l = N(() => (r || s(!0), !1), [r]), O = N(() => {
    i.current = !0, o.current = null, d([]), t == null || t(null), s(!1);
  }, [t]), $ = N(() => {
    s(!1);
  }, []), w = ((Z = o.current) == null ? void 0 : Z.fileName) ?? (e == null ? void 0 : e.fileName) ?? "this file";
  return /* @__PURE__ */ C(rt, { children: [
    /* @__PURE__ */ u(
      tn,
      {
        files: h,
        onupdatefiles: (I) => {
          d(I);
        },
        onactivatefile: S,
        onprocessfile: (I, K) => {
          if (I) return;
          const B = o.current;
          B && (i.current = !0, t == null || t({
            id: B.id,
            fileName: B.fileName,
            fileHash: B.fileHash,
            fileSize: B.fileSize,
            fileType: B.fileType
          }), d([Ge(B)]));
        },
        beforeRemoveFile: l,
        server: {
          process: {
            url: "/api/file/upload",
            method: "POST",
            headers: b ? { Authorization: `Bearer ${b}` } : {},
            onload: (I) => {
              const K = JSON.parse(I);
              return o.current = K, String(K.id);
            },
            onerror: (I) => {
              try {
                return JSON.parse(I).message || "Upload failed";
              } catch {
                return I || "Upload failed";
              }
            }
          },
          revert: null,
          load: e != null && e.fileHash ? Qe(e.fileHash) : (x = o.current) != null && x.fileHash ? Qe(o.current.fileHash) : null,
          restore: null,
          fetch: null
        },
        allowMultiple: n > 1,
        maxFiles: n,
        allowRevert: !1,
        disabled: r,
        name: "file",
        credits: !1,
        labelIdle: 'Drag & drop a file or <span class="filepond--label-action">Browse</span>'
      }
    ),
    /* @__PURE__ */ u(
      Mt,
      {
        className: "compactConfirmModal",
        title: null,
        open: a,
        onCancel: $,
        centered: !0,
        width: 400,
        zIndex: Ii,
        destroyOnHidden: !0,
        footer: /* @__PURE__ */ C(Q, { gap: 8, justify: "flex-end", children: [
          /* @__PURE__ */ u(pe, { onClick: $, children: "Cancel" }),
          /* @__PURE__ */ u(
            pe,
            {
              danger: !0,
              type: "primary",
              onClick: O,
              children: "Remove"
            }
          )
        ] }),
        children: /* @__PURE__ */ C("div", { className: Ne.confirmBody, children: [
          /* @__PURE__ */ u("div", { className: Ne.confirmIcon, "aria-hidden": !0, children: /* @__PURE__ */ u(Rt, {}) }),
          /* @__PURE__ */ C("div", { className: Ne.confirmCopy, children: [
            /* @__PURE__ */ u("p", { className: Ne.confirmTitle, children: "Remove this file?" }),
            /* @__PURE__ */ C("p", { className: Ne.confirmMessage, children: [
              "Are you sure you want to remove",
              " ",
              /* @__PURE__ */ C("span", { className: Ne.confirmFileName, children: [
                '"',
                w,
                '"'
              ] }),
              "? You can upload it again later if needed."
            ] })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ u(
      Bt,
      {
        style: { display: "none" },
        preview: {
          visible: !!c,
          src: c ?? void 0,
          onVisibleChange: (I) => {
            I || (c && URL.revokeObjectURL(c), f(null));
          }
        }
      }
    )
  ] });
}, Di = ae(
  Pi,
  le({ readOnly: "disabled" }),
  de(Oi)
), on = Ot(null), Ri = () => Pt(on), sn = Dt(
  () => Promise.resolve().then(() => Tn).then((e) => ({ default: e.FormDraw }))
), Ei = ({ value: e, entity: t }) => {
  var i;
  const n = Le((o) => {
    var a;
    return (a = o.definitions) == null ? void 0 : a[t];
  }), r = e && typeof e == "object" && !Array.isArray(e) ? e : Array.isArray(e) && e.length > 0 ? e[0] : null;
  return /* @__PURE__ */ u(jt, { size: "small", title: (i = n == null ? void 0 : n.ui) != null && i.form ? t : void 0, children: n && r ? /* @__PURE__ */ u(Be, { fallback: /* @__PURE__ */ u(Oe, {}), children: /* @__PURE__ */ u(
    sn,
    {
      entity: t,
      formMode: "create",
      initialValues: r,
      showActions: !1,
      pattern: "readPretty"
    }
  ) }) : /* @__PURE__ */ u(_e.Text, { type: "secondary", children: "No record" }) });
}, an = it(
  ({ entity: e, value: t, disabled: n = !1 }) => {
    const r = Le((h) => {
      var d;
      return (d = h.definitions) == null ? void 0 : d[e];
    }), i = U(null), o = Ue(), a = st(), s = Ri(), c = R(() => t && typeof t == "object" && !Array.isArray(t) ? t : Array.isArray(t) && t.length > 0 ? t[0] : {}, [t]), f = R(() => {
      var b;
      const h = ((b = o.address) == null ? void 0 : b.toString()) ?? "", d = h.split(".");
      return d[d.length - 1] ?? h;
    }, [o.address]), g = N(
      (h) => {
        i.current = h, s == null || s.register(f, h);
      },
      [s, f]
    );
    return Y(
      () => () => {
        s == null || s.unregister(f);
      },
      [s, f]
    ), /* @__PURE__ */ u(Q, { vertical: !0, children: r ? /* @__PURE__ */ u(jt, { size: "small", children: /* @__PURE__ */ u(Be, { fallback: /* @__PURE__ */ u(Oe, {}), children: /* @__PURE__ */ u(
      sn,
      {
        entity: e,
        formMode: "create",
        initialValues: c,
        showActions: !1,
        pattern: n ? "disabled" : "editable",
        onFormReady: g,
        parentForm: a
      }
    ) }) }) : /* @__PURE__ */ u(
      je,
      {
        image: je.PRESENTED_IMAGE_SIMPLE,
        description: /* @__PURE__ */ C(_e.Text, { type: "secondary", children: [
          'Entity "',
          e,
          '" not found'
        ] })
      }
    ) });
  }
);
an.displayName = "InlineSubformInner";
const Vi = ae(
  an,
  le({ loading: !0, readOnly: "disabled" }),
  de(Ei)
), Re = {};
function cn(e) {
  if (e == null) return Re;
  if (typeof e == "object") return e;
  if (typeof e == "string")
    try {
      const t = JSON.parse(e);
      return typeof t == "object" && t !== null ? t : Re;
    } catch {
      return Re;
    }
  return Re;
}
function $i(e) {
  return e === Re || (Array.isArray(e) ? e.length === 0 : Object.keys(e).length === 0);
}
const Mi = ({ value: e }) => {
  const t = cn(e);
  return $i(t) ? /* @__PURE__ */ u(_e.Text, { type: "secondary", children: "—" }) : /* @__PURE__ */ u(
    Jt,
    {
      data: t,
      viewOnly: !0,
      rootFontSize: 13,
      indent: 3,
      collapse: 2,
      minWidth: "100%"
    }
  );
};
function Bi({
  value: e,
  onChange: t,
  disabled: n,
  readOnly: r
}) {
  const i = U(t);
  Y(() => {
    i.current = t;
  });
  const o = N(({ newData: c }) => {
    var f;
    (f = i.current) == null || f.call(i, c);
  }, []), a = cn(e), s = n || r;
  return /* @__PURE__ */ u(
    Jt,
    {
      data: a,
      onUpdate: o,
      restrictEdit: s,
      restrictDelete: s,
      restrictAdd: s,
      restrictDrag: s,
      rootFontSize: 13,
      indent: 3,
      collapse: 2,
      minWidth: "100%"
    }
  );
}
const ji = ae(
  Bi,
  le({ readOnly: "readOnly", disabled: "disabled" }),
  de(Mi)
);
function Li() {
  const e = Ue(), t = vr(), n = [];
  return t.mapProperties((r, i) => {
    var s, c, f;
    const o = String(i), a = e.query(e.address.concat(o)).take();
    if (!((a == null ? void 0 : a.display) === "none" || (a == null ? void 0 : a.display) === "hidden") && ((s = r["x-component"]) == null ? void 0 : s.indexOf("TabPane")) > -1) {
      const g = ((c = a == null ? void 0 : a.componentProps) == null ? void 0 : c.key) ?? ((f = r == null ? void 0 : r["x-component-props"]) == null ? void 0 : f.key) ?? o;
      n.push({
        name: o,
        props: {
          ...r == null ? void 0 : r["x-component-props"],
          ...a == null ? void 0 : a.componentProps,
          key: g
        },
        schema: r
      });
    }
  }), n;
}
const Ui = at(({ name: e }) => {
  const t = Ue(), n = t.form.queryFeedbacks({
    type: "error",
    address: `${t.address.concat(e)}.*`
  });
  return n.length ? /* @__PURE__ */ u(Nr, { size: "sm", color: "red", circle: !0, style: { marginLeft: 6 }, children: n.length }) : null;
}), xi = at((e) => {
  var h;
  const t = Li(), n = (h = t[0]) == null ? void 0 : h.props.key, [r, i] = L(
    e.activeKey ?? n
  ), [o, a] = L(() => {
    var S;
    const d = /* @__PURE__ */ new Set(), b = e.activeKey ?? ((S = t[0]) == null ? void 0 : S.props.key);
    return b && d.add(b), d;
  }), s = U(null), c = Ue(), f = N(
    (d, b) => {
      if (b >= d.length) {
        c.form._tabsMounting = !1;
        return;
      }
      const S = typeof requestIdleCallback == "function" ? requestIdleCallback : (l) => setTimeout(l, 80);
      s.current = S(() => {
        In(() => {
          a((l) => {
            const O = new Set(l);
            return O.add(d[b]), O;
          });
        }), f(d, b + 1);
      });
    },
    [c.form]
  );
  return Y(() => {
    const d = r ?? n, b = t.map((S) => S.props.key).filter((S) => S !== d);
    return b.length > 0 && (c.form._tabsMounting = !0), f(b, 0), () => {
      const S = typeof cancelIdleCallback == "function" ? cancelIdleCallback : clearTimeout;
      s.current !== null && S(s.current);
    };
  }, []), /* @__PURE__ */ C(
    Ve,
    {
      value: r ?? n,
      onChange: (d) => {
        var b;
        i(d), d && a((S) => {
          if (S.has(d)) return S;
          const l = new Set(S);
          return l.add(d), l;
        }), (b = e.onChange) == null || b.call(e, d);
      },
      keepMounted: !0,
      children: [
        /* @__PURE__ */ u(Ve.List, { children: t.map(({ name: d, props: b }) => /* @__PURE__ */ C(Ve.Tab, { value: b.key, children: [
          b.tab,
          o.has(b.key) ? /* @__PURE__ */ u(Ui, { name: d }) : /* @__PURE__ */ u(At, { size: 12, style: { marginLeft: 6 } })
        ] }, b.key)) }),
        t.map(({ name: d, props: b, schema: S }) => /* @__PURE__ */ u(Ve.Panel, { value: b.key, pt: "md", children: o.has(b.key) ? /* @__PURE__ */ u(Ar, { schema: S, name: d }) : /* @__PURE__ */ u(kr, { py: "xl", children: /* @__PURE__ */ u(At, { size: "sm" }) }) }, b.key))
      ]
    }
  );
}), Hi = ({ children: e }) => /* @__PURE__ */ u(On, { children: e }), ln = Object.assign(xi, {
  TabPane: Hi
}), Ci = {
  us_phone: "(000) 000-0000",
  us_zip: [{ mask: "00000" }, { mask: "00000-0000" }],
  ssn: "000-00-0000",
  ssn_4: "0000"
};
function ze(e, t) {
  return e.replace(/\D/g, "").slice(0, t);
}
function Ke(e) {
  return e.length <= 5 ? e : `${e.slice(0, 5)}-${e.slice(5)}`;
}
function zi({
  value: e,
  onChange: t,
  ...n
}) {
  const r = U(t);
  Y(() => {
    r.current = t;
  });
  const [i, o] = L(
    () => Ke(ze(String(e ?? ""), 9))
  ), a = U(e);
  Y(() => {
    e !== a.current && (a.current = e, o(
      Ke(ze(String(e ?? ""), 9))
    ));
  }, [e]);
  const s = N((c) => {
    var g;
    const f = ze(c, 9);
    o(Ke(f)), a.current = f, (g = r.current) == null || g.call(r, f);
  }, []);
  return /* @__PURE__ */ u(
    ot,
    {
      ...n,
      value: i,
      inputMode: "numeric",
      autoComplete: "postal-code",
      maxLength: 10,
      onChange: (c) => {
        s(c.target.value);
      },
      onPaste: (c) => {
        c.preventDefault(), s(c.clipboardData.getData("text"));
      }
    }
  );
}
function Ki({
  mask: e,
  value: t,
  onChange: n,
  defaultValue: r,
  ...i
}) {
  const o = e && e !== "patient_zip" ? Ci[e] : void 0, a = typeof r == "string" ? r : void 0, s = U(n);
  Y(() => {
    s.current = n;
  });
  const [c, f] = L(
    t ?? ""
  ), g = U(t);
  Y(() => {
    t !== g.current && (g.current = t, f(t ?? ""));
  }, [t]);
  const h = N((d) => {
    var O, $, w, Z, x;
    const b = typeof (d == null ? void 0 : d.unmaskedValue) == "string" ? d.unmaskedValue : typeof ((O = d == null ? void 0 : d.detail) == null ? void 0 : O.unmaskedValue) == "string" ? d.detail.unmaskedValue : typeof (($ = d == null ? void 0 : d.target) == null ? void 0 : $.unmaskedValue) == "string" ? d.target.unmaskedValue : void 0, S = typeof (d == null ? void 0 : d.maskedValue) == "string" ? d.maskedValue : typeof ((w = d == null ? void 0 : d.detail) == null ? void 0 : w.maskedValue) == "string" ? d.detail.maskedValue : typeof ((Z = d == null ? void 0 : d.target) == null ? void 0 : Z.value) == "string" ? d.target.value : typeof d == "string" ? d : "", l = b ?? (typeof S == "string" ? S.replace(/\D/g, "") : "");
    f(S), (x = s.current) == null || x.call(s, l);
  }, []);
  return e === "patient_zip" ? /* @__PURE__ */ u(
    zi,
    {
      value: t,
      onChange: n,
      defaultValue: r,
      ...i
    }
  ) : o ? /* @__PURE__ */ u(
    Mr,
    {
      ...i,
      mask: o,
      value: c,
      defaultValue: a,
      onChange: h
    }
  ) : /* @__PURE__ */ u(
    ot,
    {
      ...i,
      value: t,
      defaultValue: r,
      onChange: n
    }
  );
}
function qi({ value: e }) {
  return /* @__PURE__ */ u("span", { children: e ?? "—" });
}
const Yi = ae(
  Ki,
  le({ readOnly: "readOnly" }),
  de(qi)
), Xe = Object.assign(Yi, {
  TextArea: tr.TextArea
}), Ji = ae(
  jn,
  le({
    value: "value",
    readOnly: "disabled"
  })
), Zi = "_linkChip_o7wro_1", Wi = "_icon_o7wro_16", Gi = "_label_o7wro_21", Qi = "_placeholder_o7wro_26", $e = {
  linkChip: Zi,
  icon: Wi,
  label: Gi,
  placeholder: Qi
};
function Xi(e) {
  return e !== null && typeof e == "object" && typeof e.url == "string" && e.url.length > 0;
}
const et = it(({ value: e }) => {
  if (!Xi(e))
    return /* @__PURE__ */ u(_e.Text, { className: $e.placeholder, children: "—" });
  const { url: t } = e, n = e.title ?? e.url;
  return /* @__PURE__ */ C(
    "a",
    {
      className: $e.linkChip,
      href: t,
      rel: "noopener noreferrer",
      target: "_blank",
      children: [
        /* @__PURE__ */ u(Pn, { className: $e.icon }),
        /* @__PURE__ */ u("span", { className: $e.label, children: n })
      ]
    }
  );
});
et.displayName = "LinkFieldInner";
const eo = ae(
  et,
  le(),
  de(et)
);
function un(e, t, n) {
  if (e != null)
    return n ? Array.isArray(e) ? e.map(
      (r) => typeof r == "object" ? r[t] : r
    ) : void 0 : typeof e == "object" && !Array.isArray(e) ? e[t] : e;
}
const to = 300;
function no(e) {
  if (!e) return [];
  const t = [];
  for (const n of Object.values(e))
    if ("dynamic" in n) {
      const r = n.dynamic.match(/^\{([\w.]+)\}$/);
      if (r) {
        const [i] = r[1].split(".");
        i && !t.includes(i) && t.push(i);
      }
    }
  return t;
}
function dn(e, t) {
  const n = e.split("."), [r] = n;
  if (!r) return;
  let i = t[r];
  if (n.length === 1) {
    if (i != null && typeof i == "object" && !Array.isArray(i))
      return i.id;
    if (typeof i == "string") {
      const o = i.trim();
      if (o.startsWith("{") && o.endsWith("}"))
        try {
          const a = JSON.parse(o);
          if (a && typeof a == "object" && !Array.isArray(a) && "id" in a)
            return a.id;
        } catch {
        }
    }
    return i;
  }
  for (let o = 1; o < n.length; o++) {
    const a = n[o];
    if (!a || i == null || typeof i != "object" || Array.isArray(i))
      return;
    i = i[a];
  }
  return i;
}
function ro(e) {
  const t = e.getFullYear(), n = String(e.getMonth() + 1).padStart(2, "0"), r = String(e.getDate()).padStart(2, "0");
  return `${t}-${n}-${r}`;
}
function io(e) {
  return e === "{today}" ? ro(/* @__PURE__ */ new Date()) : e;
}
function oo(e, t) {
  if (!e) return "";
  let n = "";
  for (const [r, i] of Object.entries(e))
    if ("static" in i) {
      const o = i.static;
      if (Array.isArray(o))
        n += `&_${r}=in:${o.map((a) => encodeURIComponent(a)).join(",")}`;
      else if (o === "!null")
        n += `&_${r}=notnull:`;
      else {
        const a = i.operator ?? "eq", s = io(o);
        n += `&_${r}=${a}:${encodeURIComponent(s)}`;
      }
    } else if ("dynamic" in i) {
      const o = i.dynamic.match(/^\{([\w.]+)\}$/);
      if (o) {
        const a = dn(
          o[1],
          t
        );
        if (a == null || a === "")
          return null;
        const s = i.operator ?? "eq";
        n += `&_${r}=${s}:${encodeURIComponent(String(a))}`;
      }
    }
  return n;
}
function so(e, t, n, r) {
  const i = n ? `&_search=${encodeURIComponent(n)}` : "";
  return `/${e}/list?limit=50${i}${r}`;
}
function tt(e) {
  let t = [];
  if (Array.isArray(e))
    t = e;
  else if (e !== null && typeof e == "object" && "data" in e) {
    const n = e.data;
    Array.isArray(n) && (t = n);
  }
  return t.filter(
    (n) => n !== null && typeof n == "object" && !Array.isArray(n)
  );
}
function fn(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "bigint" ? String(e) : "";
}
function pt(e) {
  if (e == null) return null;
  const t = fn(e);
  return t === "" ? null : t;
}
function nt(e, t, n, r) {
  return tt(e).map((i) => {
    const o = i[t];
    return {
      label: r ? Dr(r, i) : fn(o ?? ""),
      value: i[n]
    };
  });
}
function ao(e, t, n, r, i) {
  const o = {
    [t]: (n == null ? void 0 : n[t]) ?? e
  };
  if (n)
    for (const [a, s] of Object.entries(n))
      a !== t && (s === null || typeof s == "string" || typeof s == "number" || typeof s == "boolean") && (o[a] = s);
  return i !== void 0 && i !== "" && (o[r] === void 0 || o[r] === null || o[r] === "") && (o[r] = i), o;
}
const co = ({
  value: e,
  entity: t,
  labelField: n,
  nameTemplate: r,
  valueField: i,
  multiple: o = !1,
  dataSource: a
}) => {
  const s = un(e, i, o), c = Array.isArray(a), f = R(() => {
    if (c || s === void 0) return null;
    const d = Array.isArray(s) ? s : [s];
    if (d.length === 0) return null;
    const b = d.join(",");
    return `/${t}/list?limit=${d.length}&_${i}=in:${b}`;
  }, [c, s, t, i]), [g] = Je(f), h = R(() => {
    if (s === void 0) return "-";
    const d = c ? a ?? [] : [];
    if (c) {
      if (Array.isArray(s)) {
        const O = s.map(($) => {
          const w = d.find(
            (Z) => String(Z.value) === String($)
          );
          return (w == null ? void 0 : w.label) ?? String($);
        }).filter(Boolean);
        return O.length > 0 ? O.join(", ") : "-";
      }
      const l = d.find(
        (O) => String(O.value) === String(s)
      );
      return (l == null ? void 0 : l.label) ?? String(s);
    }
    if (!g.data)
      return Array.isArray(s) ? s.join(", ") : String(s);
    const b = nt(
      g.data,
      n,
      i,
      r
    );
    if (Array.isArray(s)) {
      const l = s.map((O) => {
        const $ = b.find(
          (w) => String(w.value) === String(O)
        );
        return ($ == null ? void 0 : $.label) ?? String(O);
      }).filter(Boolean);
      return l.length > 0 ? l.join(", ") : "-";
    }
    const S = b.find(
      (l) => String(l.value) === String(s)
    );
    return (S == null ? void 0 : S.label) ?? String(s);
  }, [
    s,
    g.data,
    n,
    i,
    r,
    c,
    a
  ]);
  return /* @__PURE__ */ u(Lt, { children: h });
}, mn = at(
  ({
    entity: e,
    labelField: t,
    nameTemplate: n,
    valueField: r,
    joinColumn: i,
    scalar: o = !1,
    value: a,
    onChange: s,
    multiple: c = !1,
    filter: f,
    dataSource: g,
    placeholder: h = "Search to select...",
    allowClear: d = !0,
    disabled: b = !1
  }) => {
    const S = un(a, r, c), l = Array.isArray(g), [O, $] = L(""), [w, Z] = L(""), x = U(null), I = N(() => {
      x.current && clearTimeout(x.current), $(""), Z("");
    }, []), K = st(), B = (K == null ? void 0 : K.values) ?? {}, ue = R(
      () => no(f),
      [f]
    ), P = {};
    for (const _ of ue) {
      const k = K.getValuesIn(_);
      k != null && typeof k == "object" && !Array.isArray(k) && "id" in k ? P[_] = k.id : P[_] = k;
    }
    if (f)
      for (const _ of Object.values(f)) {
        if (!("dynamic" in _)) continue;
        const k = _.dynamic.match(/^\{([\w.]+)\}$/), p = k == null ? void 0 : k[1];
        p != null && p.includes(".") && (P[p] = K.getValuesIn(p) ?? dn(p, B));
      }
    const ne = JSON.stringify(P), X = R(
      () => oo(f, B),
      // formValues ref is stable; depSnapshot carries the actual dep values.
      [f, ne]
    );
    Y(
      () => () => {
        x.current && clearTimeout(x.current);
      },
      []
    );
    const E = !l && X !== null ? so(
      e,
      t,
      w,
      X
    ) : null, [q] = Je(E), v = R(() => {
      if (l || S === void 0) return null;
      const _ = Array.isArray(S) ? S : [S];
      if (_.length === 0) return null;
      const k = _.join(",");
      return `/${e}/list?limit=${_.length}&_${r}=in:${k}${X ?? ""}`;
    }, [
      l,
      X,
      S,
      e,
      r
    ]), [F] = Je(v);
    Y(() => {
      if (l || !f || X === null || S === void 0 || !F.data) return;
      (Array.isArray(F.data) ? F.data : F.data.data ?? []).length === 0 && (s == null || s(void 0));
    }, [
      f,
      l,
      s,
      S,
      F.data
    ]);
    const H = R(() => {
      if (l)
        return g ?? [];
      const _ = q.data ? nt(q.data, t, r, n) : [], k = F.data ? nt(
        F.data,
        t,
        r,
        n
      ) : [], p = new Set(k.map((V) => String(V.value))), ee = [...k];
      for (const V of _)
        p.has(String(V.value)) || ee.push(V);
      return ee;
    }, [
      l,
      g,
      q.data,
      F.data,
      t,
      r,
      n
    ]), W = R(() => {
      const _ = /* @__PURE__ */ new Map();
      if (l) return _;
      for (const k of tt(F.data)) {
        const p = pt(k[r]);
        p !== null && _.set(p, k);
      }
      for (const k of tt(q.data)) {
        const p = pt(k[r]);
        p !== null && !_.has(p) && _.set(p, k);
      }
      return _;
    }, [l, F.data, q.data, r]), ge = U(W);
    ge.current = W;
    const he = U(H);
    he.current = H;
    const we = N(
      (_) => {
        if ($(_), !l) {
          if (x.current && clearTimeout(x.current), !_.trim()) {
            Z("");
            return;
          }
          x.current = setTimeout(() => {
            Z(_);
          }, to);
        }
      },
      [l]
    ), Se = N(
      (_) => {
        _ || I();
      },
      [I]
    ), Te = i ?? "id", Fe = N(
      (_) => {
        if (I(), o) {
          c ? s == null || s(
            Array.isArray(_) ? _ : void 0
          ) : s == null || s(
            _ ?? void 0
          );
          return;
        }
        const k = (p) => {
          var V;
          const ee = (V = he.current.find(
            (ce) => String(ce.value) === String(p)
          )) == null ? void 0 : V.label;
          return ao(
            p,
            Te,
            ge.current.get(String(p)),
            t,
            ee
          );
        };
        c ? Array.isArray(_) ? s == null || s(_.map(k)) : s == null || s(void 0) : _ != null && !Array.isArray(_) ? s == null || s(k(_)) : s == null || s(void 0);
      },
      [s, c, Te, o, I, t]
    );
    return /* @__PURE__ */ u(
      Ln,
      {
        showSearch: {
          filterOption: l ? (_, k) => ((k == null ? void 0 : k.label) ?? "").toLowerCase().includes(_.toLowerCase()) : !1,
          searchValue: O,
          onSearch: we,
          autoClearSearchValue: !0
        },
        mode: c ? "multiple" : void 0,
        value: S,
        placeholder: h,
        allowClear: d,
        disabled: b,
        loading: l ? !1 : q.isLoading || q.isFetching,
        options: H,
        onChange: Fe,
        onOpenChange: Se,
        notFoundContent: !l && q.isFetching ? "Searching..." : "No results"
      }
    );
  }
);
mn.displayName = "RelationSelectInner";
const lo = ae(
  mn,
  le(
    { loading: !0, disabled: "disabled", readOnly: "disabled" },
    (e) => ({
      ...e
    })
  ),
  de(co)
), uo = ae(
  Un,
  le({
    value: "value",
    readOnly: "disabled"
  })
), fo = "_root_1p7gd_1", mo = "_modal_1p7gd_5", yo = "_toolbar_1p7gd_10", go = "_addRowButton_1p7gd_16", ho = "_csvExportButton_1p7gd_17", De = {
  root: fo,
  modal: mo,
  toolbar: yo,
  addRowButton: go,
  csvExportButton: ho
}, Tt = Dt(
  () => Promise.resolve().then(() => Tn).then((e) => ({ default: e.FormDraw }))
);
function bo(e) {
  var r, i;
  const t = ((i = (r = e == null ? void 0 : e.ui) == null ? void 0 : r.table) == null ? void 0 : i.columns) ?? [], n = (e == null ? void 0 : e.columns) ?? {};
  return t.filter((o) => n[o]).map((o) => {
    var a, s;
    return {
      key: o,
      title: ((s = (a = n[o]) == null ? void 0 : a.ui) == null ? void 0 : s.label) ?? o
    };
  });
}
let So = 0;
function yn() {
  return `sf_${Date.now()}_${++So}`;
}
function gn(e) {
  return typeof e._key == "string" && e._key.length > 0 ? e._key : e.id !== void 0 && e.id !== null && e.id !== "" ? `sf_id_${e.id}` : yn();
}
function hn(e, t) {
  return typeof e._key == "string" && e._key.length > 0 ? e._key : e.id !== void 0 && e.id !== null && e.id !== "" ? `sf_id_${e.id}` : `sf_idx_${t}`;
}
function bn(e) {
  return {
    data: { data: e.filter((t) => !t.deleted) },
    error: null,
    isLoading: !1
  };
}
const Fo = ({ value: e, entity: t }) => {
  const n = Le((o) => {
    var a;
    return (a = o.definitions) == null ? void 0 : a[t];
  }), r = Array.isArray(e) ? e.length : 0, i = R(
    () => bn(
      (e || []).map((o) => ({
        ...o,
        _key: gn(o)
      }))
    ),
    [e]
  );
  return /* @__PURE__ */ u(Q, { vertical: !0, children: n && r > 0 ? /* @__PURE__ */ u(
    Yt,
    {
      entity: t,
      gridData: i,
      getRowID: hn
    }
  ) : /* @__PURE__ */ u(Lt, { children: "No records" }) });
}, Sn = it(
  ({
    entity: e,
    value: t,
    onChange: n,
    disabled: r = !1,
    disableAddRow: i = !1,
    enableCsvExport: o = !1
  }) => {
    const a = Le((v) => {
      var F;
      return (F = v.definitions) == null ? void 0 : F[e];
    }), s = U(null), c = U(!1), f = st(), [g, h] = L(!1), [d, b] = L({
      open: !1,
      mode: "create",
      editKey: null,
      initialValues: void 0
    }), S = R(
      () => (t || []).map((v) => ({
        ...v,
        _key: gn(v)
      })),
      [t]
    ), l = N(
      (v, F) => hn(v, F),
      []
    ), O = R(
      () => S.filter((v) => !v.deleted),
      [S]
    ), $ = R(
      () => a ? bo(a) : [],
      [a]
    ), w = R(() => bn(S), [S]), Z = N(() => {
      if ($.length === 0 || O.length === 0)
        return;
      const v = Qr(
        O,
        $
      );
      Xr(v, ei(e));
    }, [e, $, O]), x = N(
      (v) => {
        const F = S.find((H) => H._key === v);
        F && (F.id ? n == null || n(
          S.map(
            (H) => H._key === v ? { ...H, deleted: !0, archived: !0 } : H
          )
        ) : n == null || n(S.filter((H) => H._key !== v)));
      },
      [S, n]
    ), I = N(
      (v) => {
        r || (c.current = !1, h(!1), b({
          open: !0,
          mode: "edit",
          editKey: v._key || null,
          initialValues: v
        }));
      },
      [r]
    ), K = N(() => {
      c.current = !1, h(!1), b({
        open: !0,
        mode: "create",
        editKey: null,
        initialValues: void 0
      });
    }, []), B = N(() => {
      b({
        open: !1,
        mode: "create",
        editKey: null,
        initialValues: void 0
      });
    }, []), ue = N(async () => {
      if (!(!s.current || c.current)) {
        c.current = !0, h(!0);
        try {
          await s.current.submit(), B();
        } catch {
        } finally {
          c.current = !1, h(!1);
        }
      }
    }, [B]), P = N(
      async (v) => {
        if (d.mode === "create") {
          const H = {
            ...v,
            _key: yn()
          };
          return n == null || n([...S, H]), H;
        }
        const F = S.map(
          (H) => H._key === d.editKey ? { ...v, _key: d.editKey } : H
        );
        return n == null || n(F), { ...v, _key: d.editKey };
      },
      [d.mode, d.editKey, S, n]
    ), ne = N((v) => {
      s.current = v;
    }, []), X = N(
      (v) => /* @__PURE__ */ u(
        pe,
        {
          type: "text",
          danger: !0,
          size: "small",
          icon: /* @__PURE__ */ u(Rt, {}),
          onClick: (F) => {
            F.stopPropagation(), x(v._key);
          }
        }
      ),
      [x]
    ), E = R(
      () => a && !r && !i,
      [a, r, i]
    ), q = R(
      () => o && $.length > 0 && O.length > 0,
      [o, $.length, O.length]
    );
    return /* @__PURE__ */ C(Q, { vertical: !0, gap: 12, className: De.root, children: [
      a ? /* @__PURE__ */ u(
        Yt,
        {
          entity: e,
          gridData: w,
          onRowClick: r ? void 0 : I,
          actions: r ? void 0 : X,
          getRowID: l
        }
      ) : /* @__PURE__ */ u(
        je,
        {
          image: je.PRESENTED_IMAGE_SIMPLE,
          description: /* @__PURE__ */ C(_e.Text, { type: "secondary", children: [
            'Entity "',
            e,
            '" not found'
          ] })
        }
      ),
      (E || q) && /* @__PURE__ */ C(Q, { gap: 8, wrap: "wrap", className: De.toolbar, children: [
        E && /* @__PURE__ */ u(
          pe,
          {
            type: "primary",
            ghost: !0,
            onClick: K,
            icon: /* @__PURE__ */ u(Dn, {}),
            size: "small",
            className: De.addRowButton,
            children: "Add Row"
          }
        ),
        q && /* @__PURE__ */ u(
          pe,
          {
            icon: /* @__PURE__ */ u(Rn, {}),
            onClick: Z,
            size: "small",
            className: De.csvExportButton,
            children: "Download CSV"
          }
        )
      ] }),
      /* @__PURE__ */ u(
        Mt,
        {
          open: d.open,
          onCancel: B,
          onOk: () => {
            ue();
          },
          confirmLoading: g,
          okButtonProps: { disabled: g },
          title: d.mode === "create" ? "Add Record" : "Edit Record",
          width: "80vw",
          className: De.modal,
          centered: !0,
          destroyOnHidden: !0,
          maskClosable: !1,
          children: d.open && (d.mode === "create" ? /* @__PURE__ */ u(Be, { fallback: /* @__PURE__ */ u(Oe, {}), children: /* @__PURE__ */ u(
            Tt,
            {
              entity: e,
              formMode: "create",
              initialValues: d.initialValues,
              showActions: !1,
              onFormReady: ne,
              onSubmit: P,
              parentForm: f
            }
          ) }) : /* @__PURE__ */ u(Be, { fallback: /* @__PURE__ */ u(Oe, {}), children: /* @__PURE__ */ u(
            Tt,
            {
              entity: e,
              formMode: "edit",
              formID: d.editKey || "",
              initialValues: d.initialValues,
              showActions: !1,
              onFormReady: ne,
              onSubmit: P,
              parentForm: f
            }
          ) }))
        }
      )
    ] });
  }
);
Sn.displayName = "SubformTableInner";
const _o = ae(
  Sn,
  le({ loading: !0, readOnly: "disabled" }),
  de(Fo)
);
function wo(e) {
  return e.split("_").map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join(" ");
}
function dt(e) {
  return typeof e == "string" ? e : typeof e == "number" || typeof e == "boolean" ? String(e) : typeof e == "bigint" || typeof e == "symbol" || typeof e == "function" ? e.toString() : JSON.stringify(e);
}
function qe(e) {
  return e == null ? "-" : typeof e == "object" ? JSON.stringify(e) : dt(e);
}
const Ao = ({
  value: e,
  columns: t
}) => {
  if (e == null)
    return /* @__PURE__ */ u("span", { style: { color: "#999" }, children: "-" });
  if (typeof e != "object")
    return /* @__PURE__ */ u("span", { children: dt(e) });
  if (Array.isArray(e)) {
    if (e.length === 0)
      return /* @__PURE__ */ u("span", { style: { color: "#999" }, children: "No rows" });
    if (typeof e[0] == "object" && e[0] !== null) {
      const a = (t ?? Object.keys(e[0]).map((s) => ({
        key: s,
        title: wo(s)
      }))).map(({ key: s, title: c }) => ({
        title: c,
        dataIndex: s,
        key: s,
        render: (f) => qe(f)
      }));
      return /* @__PURE__ */ u(
        He,
        {
          columns: a,
          dataSource: e.map((s, c) => ({
            ...s,
            key: c
          })),
          size: "small",
          pagination: e.length > 20 ? { pageSize: 20, showSizeChanger: !1 } : !1,
          bordered: !0
        }
      );
    }
    return /* @__PURE__ */ u(
      He,
      {
        columns: [
          { title: "Index", dataIndex: "index", key: "index", width: 80 },
          {
            title: "Value",
            dataIndex: "value",
            key: "value",
            render: (o) => qe(o)
          }
        ],
        dataSource: e.map((o, a) => ({
          key: a,
          index: a,
          value: o
        })),
        size: "small",
        pagination: !1,
        bordered: !0
      }
    );
  }
  const n = Object.entries(e);
  return n.length === 0 ? /* @__PURE__ */ u("span", { style: { color: "#999" }, children: "Empty object" }) : /* @__PURE__ */ u(
    He,
    {
      columns: [
        { title: "Key", dataIndex: "keyName", key: "keyName", width: 150 },
        {
          title: "Value",
          dataIndex: "value",
          key: "value",
          render: (i) => qe(i)
        }
      ],
      dataSource: n.map(([i, o]) => ({
        key: i,
        keyName: i,
        value: o
      })),
      size: "small",
      pagination: !1,
      bordered: !0
    }
  );
}, vo = ({
  value: e,
  onChange: t,
  ...n
}) => {
  const r = typeof e == "object" && e !== null ? JSON.stringify(e, null, 2) : e == null ? "" : dt(e), i = (o) => {
    const a = o.target.value;
    try {
      const s = JSON.parse(a);
      t == null || t(s);
    } catch {
      t == null || t(a);
    }
  };
  return /* @__PURE__ */ u(
    ot.TextArea,
    {
      ...n,
      value: r,
      onChange: i,
      rows: 6
    }
  );
}, po = ae(
  vo,
  de(Ao)
), To = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AlertFormItem: ci,
  ClearableRadioGroup: di,
  DateField: gi,
  DateTimeField: bi,
  FileUpload: Di,
  InlineSubform: Vi,
  JsonField: ji,
  JsonTable: po,
  LinkField: eo,
  MantineFormTab: ln,
  MaskedInput: Xe,
  Rate: Ji,
  RelationSelect: lo,
  Slider: uo,
  SubformTable: _o,
  TimeField: wi
}, Symbol.toStringTag, { value: "Module" }));
J.extend(Br);
const Fn = (e) => {
  const { value: t } = e;
  if (t == null || t === "") return "";
  const n = new Date(t);
  if (Number.isNaN(n.getTime())) return "Invalid date";
  const r = /* @__PURE__ */ new Date();
  return r.setHours(23, 59, 59, 999), n > r ? "Date cannot be in the future" : "";
}, _n = (e) => {
  const { value: t } = e;
  if (t == null || t === "") return "";
  const n = new Date(t);
  if (Number.isNaN(n.getTime())) return "Invalid date";
  const r = /* @__PURE__ */ new Date();
  return r.setHours(0, 0, 0, 0), n < r ? "Date cannot be in the past" : "";
}, ko = (e) => {
  const { value: t } = e;
  if (t == null || t === "") return "";
  const n = typeof t == "string" ? t : "";
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(n) ? "" : "Invalid email format";
}, No = (e) => {
  const { value: t } = e;
  return t == null || t === "" ? "" : (typeof t == "string" ? t : "").replace(/\D/g, "").length !== 10 ? "Phone number must be 10 digits" : "";
}, Io = (e) => {
  const { value: t } = e;
  return t == null || t === "" ? "" : (typeof t == "string" ? t : "").replace(/\D/g, "").length !== 9 ? "SSN must be 9 digits" : "";
}, Oo = (e) => {
  const { value: t } = e;
  if (t == null || t === "") return "";
  const n = typeof t == "string" ? t : "";
  return /^\d{5}(-\d{4})?$/.test(n) ? "" : "Invalid ZIP code format";
}, Po = (e, t, n) => {
  const { value: r } = e;
  if (!r) return "";
  const i = typeof r == "string" ? r : String(r), o = n == null ? void 0 : n.min;
  return i.length < o ? `Must be at least ${o} characters` : "";
}, Do = (e, t, n) => {
  const { value: r } = e;
  if (!r) return "";
  const i = typeof r == "string" ? r : String(r), o = n == null ? void 0 : n.max;
  return i.length > o ? `Must be at most ${o} characters` : "";
}, Ro = (e, t, n) => {
  const { value: r } = e;
  if (!r) return "";
  const i = typeof r == "number" ? r : Number(r), o = n == null ? void 0 : n.min, a = n == null ? void 0 : n.max;
  return i < o || i > a ? `Must be between ${o} and ${a}` : "";
}, Eo = (e, t, n) => {
  const { value: r } = e;
  if (!r) return "";
  const i = new Date(r);
  if (Number.isNaN(i.getTime())) return "Invalid date";
  const o = n == null ? void 0 : n.field;
  if (!o) return "";
  const a = new Date(o);
  return Number.isNaN(a.getTime()) ? "" : i <= a ? "Date must be after {field}" : "";
}, Vo = (e, t, n) => {
  const { value: r } = e;
  if (!r) return "";
  const i = new Date(r);
  if (Number.isNaN(i.getTime())) return "Invalid date";
  const o = n == null ? void 0 : n.field;
  if (!o) return "";
  const a = new Date(o);
  return Number.isNaN(a.getTime()) ? "" : i >= a ? "Date must be before {field}" : "";
}, $o = (e) => {
  const { value: t } = e;
  return t && (typeof t == "string" ? t : "").replace(/\D/g, "").length !== 10 ? "NPI must be 10 digits" : "";
}, Mo = (e) => {
  const { value: t } = e;
  if (!t) return "";
  const n = typeof t == "string" ? t : "";
  return /^[A-Za-z]{2}[A-Za-z0-9]{0,12}$/.test(n) ? "" : "Invalid Medicaid ID format";
}, Bo = (e) => {
  const { value: t } = e;
  if (!t) return "";
  const n = (typeof t == "string" ? t : String(t)).replace(/-/g, "").replace(/\s/g, "");
  return /^\d{8,11}$/.test(n) ? "" : "NDC must be 8–11 digits (dashes optional)";
}, jo = (e) => {
  var s, c, f;
  const { value: t } = e;
  if (t == null || t === "")
    return (s = e == null ? void 0 : e.setFeedback) == null || s.call(e, {
      type: "warning",
      messages: []
    }), "";
  const n = new Date(t);
  if (Number.isNaN(n.getTime())) return "";
  const r = /* @__PURE__ */ new Date();
  if (r.setHours(23, 59, 59, 999), n > r) return "Date of birth cannot be in the future";
  const i = /* @__PURE__ */ new Date();
  let o = i.getFullYear() - n.getFullYear();
  const a = i.getMonth() - n.getMonth();
  return (a < 0 || a === 0 && i.getDate() < n.getDate()) && o--, o < 18 ? (c = e == null ? void 0 : e.setFeedback) == null || c.call(e, {
    type: "warning",
    messages: ["Patient is under 18 years old"]
  }) : (f = e == null ? void 0 : e.setFeedback) == null || f.call(e, {
    type: "warning",
    messages: []
  }), "";
}, Lo = /^[A-Za-z0-9,'\-.\s]*$/, Uo = (e) => {
  const { value: t } = e;
  return t == null || t === "" || Lo.test(t) ? "" : "Only letters, numbers, commas, apostrophes, hyphens, periods, and spaces are allowed";
}, xo = (e) => {
  const { value: t } = e;
  return t == null || t === "" || typeof t == "string" && (e.value = t.toLowerCase()), "";
}, Ho = (e) => {
  const { value: t } = e;
  return t == null || t === "" || typeof t == "string" && (e.value = t.trim()), "";
}, Co = (e) => {
  const { value: t } = e;
  return t == null || t === "" || typeof t == "string" && (e.value = t.toUpperCase()), "";
}, zo = (e) => {
  const { value: t } = e;
  if (t == null || t === "") return "";
  const n = typeof t == "string" ? t : String(t);
  return /^[a-zA-Z0-9]*$/.test(n) ? "" : "Must be alpha-numeric";
}, Ko = (e) => {
  const { value: t } = e;
  return t == null || t === "" || (typeof t == "string" ? t : "").match(/^[^ \t\n]+@[^. \n\t]+(\.[^. \t\n]+)+/) ? "" : "Address must be in the form of id@domain.";
}, qo = (e) => {
  const { value: t } = e;
  return t == null || t === "" ? "" : (typeof t == "string" ? t : "").replace(/\D/g, "").length !== 9 ? "SSN must be 9 digits" : "";
}, Yo = (e) => {
  const { value: t } = e;
  if (t == null || t === "") return "";
  const n = String(t);
  return /^\d{1,4}$/.test(n) ? "" : "SSN Last 4 must contain only digits";
}, Jo = (e) => {
  const { value: t } = e;
  if (t == null || t === "") return "";
  const n = typeof t == "string" ? t.trim() : "";
  return n.length === 0 || /^https:\/\//i.test(n) ? "" : "Must begin with https://";
}, wn = (e, t, n) => {
  const { value: r } = e;
  if (!r) return "";
  const i = n == null ? void 0 : n.require;
  return i === "past" ? Fn(e) : i === "future" ? _n(e) : "";
}, Zo = (e, t, n) => wn(e, t, n), Wo = (e, t, n) => {
  var o, a;
  const { value: r } = e;
  if (!r) return "";
  const i = J(r);
  if (n != null && n.beforeField) {
    const s = (o = t.form.getFieldState(
      n.beforeField
    )) == null ? void 0 : o.value;
    if (s && i.isAfter(J(s)))
      return (n == null ? void 0 : n.message) || "Date must be before the other date";
  }
  if (n != null && n.afterField) {
    const s = (a = t.form.getFieldState(n.afterField)) == null ? void 0 : a.value;
    if (s && i.isBefore(J(s)))
      return (n == null ? void 0 : n.message) || "Date must be after the other date";
  }
  return "";
}, Go = (e, t, n) => {
  var s, c;
  const r = (n == null ? void 0 : n.startField) || "start_date", i = (n == null ? void 0 : n.endField) || "end_date", o = (s = t.form.getFieldState(r)) == null ? void 0 : s.value, a = (c = t.form.getFieldState(i)) == null ? void 0 : c.value;
  return !o || !a ? "" : J(o).isAfter(J(a)) ? "Start date must be before end date" : "";
}, An = (e, t, n) => {
  var a;
  const { value: r } = e;
  if (!r) return "";
  const i = (n == null ? void 0 : n.startField) || "scheduled_start", o = (a = t.form.getFieldState(i)) == null ? void 0 : a.value;
  return o && J(r).isBefore(J(o)) ? "End date/time must be after start date/time" : "";
}, Qo = (e, t, n) => An(e, t, n), Xo = (e, t, n) => {
  var d, b;
  if (!Array.isArray(n == null ? void 0 : n.fields) || (n == null ? void 0 : n.fields.length) < 2)
    return "";
  const r = String(n.fields[0]), i = (S) => {
    const l = t.form.query(r).take();
    l && qt(l) && l.setSelfErrors(S);
  }, o = (d = t.form.getFieldState(r)) == null ? void 0 : d.value;
  if (o == null || o === "")
    return i([]), "";
  const a = Number(o);
  if (Number.isNaN(a))
    return i([]), "";
  const s = n.fields[1];
  if (!s)
    return i([]), "";
  const c = Number((b = t.form.getFieldState(s)) == null ? void 0 : b.value);
  if (Number.isNaN(c))
    return i([]), "";
  const f = n.operator ?? n.require ?? "gt", g = n.error ?? `Must be ${f} than ${s}`;
  let h = "";
  switch (f) {
    case "gt":
      h = a > c ? "" : g || `Must be greater than ${s}`;
      break;
    case "gte":
      h = a >= c ? "" : g || `Must be greater than or equal to ${s}`;
      break;
    case "lt":
      h = a < c ? "" : g || `Must be less than ${s}`;
      break;
    case "lte":
      h = a <= c ? "" : g || `Must be less than or equal to ${s}`;
      break;
    case "eq":
      h = a === c ? "" : g || `Must equal ${s}`;
      break;
    default:
      h = "";
  }
  return i(h ? [h] : []), "";
}, es = (e, t, n) => {
  var s;
  const { value: r } = e;
  if (!Array.isArray(r) || r.length === 0) return "";
  const i = n == null ? void 0 : n.otherField;
  if (!i) return "";
  const o = (s = t.form.getFieldState(i)) == null ? void 0 : s.value;
  if (!Array.isArray(o) || o.length === 0) return "";
  const a = r.filter((c) => o.includes(c));
  return a.length > 0 ? (n == null ? void 0 : n.message) || `These values overlap with ${i}: ${a.join(", ")}` : "";
}, ts = (e, t, n) => {
  var o;
  const { value: r } = e;
  if (!r) return "";
  const i = (n == null ? void 0 : n.values) || [];
  return i.length === 0 || i.includes(String(r)) && ((o = e.setFeedback) == null || o.call(e, {
    type: "warning",
    messages: [
      (n == null ? void 0 : n.message) || "This value is flagged as high risk"
    ]
  })), "";
}, ns = (e, t, n) => {
  var c;
  const r = (n == null ? void 0 : n.sourceField) || e.path.toString(), i = (n == null ? void 0 : n.targetField) || "age", o = r === e.path.toString() ? e.value : (c = t.form.getFieldState(r)) == null ? void 0 : c.value;
  if (!o)
    return t.form.setFieldState(i, (f) => {
      f.value = null;
    }), "";
  const a = J(o);
  if (!a.isValid()) return "";
  const s = J().diff(a, "year");
  try {
    t.form.setFieldState(i, (f) => {
      f.value = s;
    });
  } catch {
  }
  return "";
}, rs = (e, t, n) => {
  const { value: r } = e;
  if (!r && r !== 0) return "";
  const i = Number(r);
  if (Number.isNaN(i)) return "";
  const o = Math.floor(i / 12), a = i % 12, s = `${o}'${a}"`, c = (n == null ? void 0 : n.displayField) || "height_display";
  try {
    t.form.setFieldState(c, (f) => {
      f.value = s;
    });
  } catch {
  }
  return "";
}, is = (e, t, n) => {
  const { value: r } = e;
  if (!r && r !== 0) return "";
  const i = Number(r);
  if (Number.isNaN(i)) return "";
  const o = (n == null ? void 0 : n.unit) || "lbs", a = (n == null ? void 0 : n.displayField) || "weight_display";
  try {
    t.form.setFieldState(a, (s) => {
      s.value = `${i} ${o}`;
    });
  } catch {
  }
  return "";
}, vn = (e, t, n) => {
  var g, h;
  const r = n == null ? void 0 : n.startField, i = n == null ? void 0 : n.endField, o = n == null ? void 0 : n.targetField;
  if (!r || !i || !o) return "";
  const a = (g = t.form.getFieldState(r)) == null ? void 0 : g.value, s = (h = t.form.getFieldState(i)) == null ? void 0 : h.value;
  if (!a || !s) return "";
  const c = (n == null ? void 0 : n.unit) || "minutes", f = J(s).diff(
    J(a),
    c
  );
  try {
    t.form.setFieldState(o, (d) => {
      d.value = f;
    });
  } catch {
  }
  return "";
}, os = (e, t, n) => vn(e, t, n), ss = (e) => {
  const { value: t } = e;
  if (!t) return "";
  const n = J.utc(t).local().format("YYYY-MM-DD HH:mm");
  return e.value = n, "";
}, as = (e, t, n) => {
  const r = (n == null ? void 0 : n.fields) || [], i = (n == null ? void 0 : n.separator) ?? " ", o = n == null ? void 0 : n.targetField;
  if (!r.length || !o) return "";
  const a = r.map((s) => {
    var c;
    return (c = t.form.getFieldState(s)) == null ? void 0 : c.value;
  }).filter((s) => s != null && s !== "");
  try {
    t.form.setFieldState(o, (s) => {
      s.value = a.join(i);
    });
  } catch {
  }
  return "";
}, cs = (e, t, n) => {
  var a;
  const r = n == null ? void 0 : n.sourceField, i = n == null ? void 0 : n.targetField;
  if (!r || !i) return "";
  const o = (a = t.form.getFieldState(r)) == null ? void 0 : a.value;
  try {
    t.form.setFieldState(i, (s) => {
      s.value = o;
    });
  } catch {
  }
  return "";
}, ls = (e, t, n) => {
  const r = (n == null ? void 0 : n.fields) || [];
  for (const i of r)
    try {
      t.form.setFieldState(i, (o) => {
        o.value = void 0;
      });
    } catch {
    }
  return "";
}, us = (e, t, n) => {
  if (t.formMode !== "edit" || !t.editID) return "";
  const r = (n == null ? void 0 : n.targetField) || e.path.toString();
  try {
    t.form.setFieldState(r, (i) => {
      i.value = t.editID;
    });
  } catch {
  }
  return "";
}, ds = (e, t, n) => {
  const r = n == null ? void 0 : n.tabField;
  if (!r) return "";
  const i = e.value, o = (n == null ? void 0 : n.prefix) || "";
  try {
    t.form.setFieldState(r, (a) => {
      a.title = i ? `${o}${i}` : o;
    });
  } catch {
  }
  return "";
}, fs = (e, t, n) => {
  if (t.formMode !== "create") return "";
  const r = n == null ? void 0 : n.roleMap;
  if (!r) return "";
  const i = en();
  return i && r[i] !== void 0 && (e.value = r[i]), "";
}, ms = (e, t, n) => {
  var a;
  const r = (n == null ? void 0 : n.sourceField) || "job_title", i = (n == null ? void 0 : n.targetField) || "name", o = r === e.path.toString() ? e.value : (a = t.form.getFieldState(r)) == null ? void 0 : a.value;
  if (!o) return "";
  try {
    t.form.setFieldState(i, (s) => {
      s.value || (s.value = o);
    });
  } catch {
  }
  return "";
}, ys = (e, t, n) => {
  const { value: r } = e;
  if (!r) return "";
  const i = (n == null ? void 0 : n.entity) || t.entity, o = (n == null ? void 0 : n.field) || "email";
  return (async () => {
    var a;
    try {
      const s = ie(
        `/${i}/list?_${o}=eq:${encodeURIComponent(String(r))}&limit=1`
      ), c = await re(s);
      (Array.isArray(c) ? c : (c == null ? void 0 : c.data) || []).some(
        (h) => String(h.id) !== String(t.editID || "")
      ) && ((a = e.setFeedback) == null || a.call(e, {
        type: "error",
        messages: ["This email is already in use"]
      }));
    } catch {
    }
  })(), "";
}, gs = (e, t, n) => {
  const { value: r } = e;
  if (!r) return "";
  const i = (typeof r == "string" ? r : "").replace(/\D/g, "");
  if (i.length !== 10) return "Phone number must be 10 digits";
  const o = (n == null ? void 0 : n.entity) || t.entity, a = (n == null ? void 0 : n.field) || "phone";
  return (async () => {
    var s;
    try {
      const c = ie(
        `/${o}/list?_${a}=eq:${encodeURIComponent(i)}&limit=1`
      ), f = await re(c);
      (Array.isArray(f) ? f : (f == null ? void 0 : f.data) || []).some(
        (d) => String(d.id) !== String(t.editID || "")
      ) && ((s = e.setFeedback) == null || s.call(e, {
        type: "error",
        messages: ["This phone number is already in use"]
      }));
    } catch {
    }
  })(), "";
}, hs = (e, t, n) => {
  const { value: r } = e;
  if (!r) return "";
  const i = (n == null ? void 0 : n.entity) || t.entity, o = (n == null ? void 0 : n.field) || e.path.toString().split(".").pop() || "", a = (n == null ? void 0 : n.message) || (n == null ? void 0 : n.error) || `This ${o} is already in use`;
  return (async () => {
    var s;
    try {
      const c = ie(
        `/${i}/list?_${o}=eq:${encodeURIComponent(String(r))}&limit=1`
      ), f = await re(c);
      (Array.isArray(f) ? f : (f == null ? void 0 : f.data) || []).some(
        (d) => String(d.id) !== String(t.editID || "")
      ) && ((s = e.setFeedback) == null || s.call(e, { type: "error", messages: [a] }));
    } catch {
    }
  })(), "";
}, bs = (e, t, n) => {
  var s;
  const r = n == null ? void 0 : n.return_modes;
  if (r != null && r.includes(t.formMode) || !(n != null && n.id_field))
    return "";
  const i = (s = t.form.getFieldState(n.id_field).value) == null ? void 0 : s.id;
  if (!i) return "";
  const o = n == null ? void 0 : n.target, a = n == null ? void 0 : n.copy;
  return !o || !a || (async () => {
    try {
      const c = ie(`/${o}/${i}`), f = await re(c);
      if (!f) return;
      for (const [g, h] of Object.entries(a))
        if (f[g] !== void 0)
          try {
            t.form.setFieldState(h, (d) => {
              d.value = f[g];
            });
          } catch {
          }
    } catch {
    }
  })(), "";
}, Ss = (e, t, n) => {
  const { value: r } = e;
  if (!r) return "";
  const i = (n == null ? void 0 : n.displayField) || "tracking_link_display";
  try {
    t.form.setFieldState(i, (o) => {
      o.value = String(r);
    });
  } catch {
  }
  return "";
}, Fs = {
  dateInPast: Fn,
  dateNotPast: _n,
  emailFormat: ko,
  usPhoneFormat: No,
  ssnFormat: Io,
  zipCodeFormat: Oo,
  minLength: Po,
  maxLength: Do,
  between: Ro,
  dateAfterField: Eo,
  dateBeforeField: Vo,
  npiFormat: $o,
  medicaidIDFormat: Mo,
  NDCFormatValidator: Bo,
  DOBValidator: jo,
  NameValidator: Uo,
  // String transforms
  LowerCase: xo,
  Trim: Ho,
  UpperCase: Co,
  // Format validators
  AlphaNumValidator: zo,
  EmailValidator: Ko,
  SSNValidator: qo,
  SSNLast4Validator: Yo,
  SecureURLValidator: Jo,
  // Date validators
  DateValidator: wn,
  DateTimeValidator: Zo,
  DateOrderValidator: Wo,
  StartEndDateValidation: Go,
  ScheduledEndValidate: An,
  ScheduledEndValidateLab: Qo,
  // Numeric validators
  CompareValidator: Xo,
  // Array / exclusive
  ExclusiveValidator: es,
  HighRiskWarning: ts,
  // Field transforms / effects
  AgeTransform: ns,
  HeightTransform: rs,
  WeightTransform: is,
  TimeDifference: vn,
  DateTimeDifference: os,
  Timetransform: ss,
  MergeFields: as,
  CopyLocalField: cs,
  ClearChildFields: ls,
  GetFormidValidator: us,
  UpdateTabLabel: ds,
  RoleBasedFieldTransform: fs,
  JobTitleTransform: ms,
  // Async / API-based validators
  EmailUniqueValidator: ys,
  PhoneNumberValidator: gs,
  CustomUniqueValidator: hs,
  CopyData: bs,
  TrackingLinkTransform: Ss
};
function _s(e) {
  return e !== null && typeof e == "object" && "field" in e;
}
function ws(e, t) {
  var r, i;
  const n = {};
  for (const [o, a] of Object.entries(e))
    _s(a) ? n[o] = (i = (r = t == null ? void 0 : t.form) == null ? void 0 : r.values) == null ? void 0 : i[a.field] : n[o] = a;
  return n;
}
const ft = /* @__PURE__ */ new Map();
function za(e) {
  for (const { name: t, component: n } of e)
    ft.set(t, n);
}
function As() {
  return Object.fromEntries(ft);
}
function Ka() {
  ft.clear();
}
const xe = /* @__PURE__ */ new Map();
function qa(e) {
  for (const { name: t, handler: n } of e)
    xe.set(t, n);
}
function Ya(e) {
  for (const [t, n] of Object.entries(e))
    xe.set(t, n);
}
function vs(e) {
  return xe.get(e) ?? Fs[e];
}
function Ja() {
  xe.clear();
}
const ps = ({ form: e, values: t }) => {
  const n = e.query("confirm_password").take();
  if (!n || !qt(n))
    return { passed: !0 };
  const { password: r, confirm_password: i } = t;
  return !r && !i ? { passed: !0 } : (n.setFeedback({
    type: "error",
    code: "FormValidatorError",
    messages: []
  }), r !== i ? (n.setFeedback({
    type: "error",
    code: "FormValidatorError",
    messages: ["Passwords do not match"]
  }), { passed: !1, message: "Passwords do not match" }) : { passed: !0 });
}, Ts = async ({
  form: e,
  values: t,
  entity: n,
  formMode: r
}) => {
  const i = e.__combinationFields;
  if (!i || i.length === 0)
    return { passed: !0 };
  const o = i.map((a) => {
    const s = t[a];
    return s != null && s !== "" ? `_${a}=eq:${encodeURIComponent(String(s))}` : null;
  }).filter(Boolean);
  if (o.length !== i.length)
    return { passed: !0 };
  try {
    const { buildApiUrl: a, fetchAPI: s } = await import("./index-DO-P_QzK.js"), c = a(
      `/${n}/list?${o.join("&")}&limit=1`
    ), f = await s(c), g = Array.isArray(f) ? f : (f == null ? void 0 : f.data) || [], h = r === "edit" ? t.id || e.__editID : null;
    if (g.some(
      (b) => String(b.id) !== String(h || "")
    ))
      return {
        passed: !1,
        message: `This combination of ${i.join(", ")} already exists`
      };
  } catch {
  }
  return { passed: !0 };
}, ks = [
  ps,
  Ts
], mt = [];
function Za(e) {
  mt.push(...e);
}
function Wa() {
  mt.length = 0;
}
async function Ns(e) {
  const t = mt.filter(
    (i) => i.entityPattern === e.entity || i.entityPattern === "*"
  ), n = [
    ...ks,
    ...t.map((i) => i.validator)
  ];
  let r = { ...e.values };
  for (const i of n)
    try {
      const o = await i({ ...e, values: r });
      if (o && !o.passed)
        return {
          passed: !1,
          message: o.message || "Form validation failed"
        };
      o != null && o.values && (r = { ...r, ...o.values });
    } catch (o) {
      return {
        passed: !1,
        message: o instanceof Error ? o.message : "Form validation failed"
      };
    }
  return { passed: !0, values: r };
}
const Is = "_formContainer_1h67i_2", Os = "_formActions_1h67i_86", kt = {
  formContainer: Is,
  formActions: Os
}, Ps = ({ title: e }) => e ? /* @__PURE__ */ u(xn, { titlePlacement: "left", children: e }) : null;
async function Ds(e, t, n) {
  var a;
  const r = /* @__PURE__ */ new Map(), i = Object.keys(t).map(async (s) => {
    const c = n[s];
    if (c)
      try {
        const f = await Kn(s, c);
        r.set(s, f);
      } catch (f) {
        console.error(
          `Failed to fetch prefill data for ${s}:`,
          f
        );
      }
  });
  await Promise.all(i);
  const o = {};
  for (const [s, c] of Object.entries(e)) {
    const f = (a = c.ui) == null ? void 0 : a.prefill;
    if (!f) continue;
    const g = Array.isArray(f) ? f : [f], h = [];
    for (const d of g) {
      const b = d.indexOf("."), S = b === -1 ? d : d.substring(0, b), l = b === -1 ? s : d.substring(b + 1), O = r.get(S);
      if (O != null && O[l]) {
        h.push(O[l]);
        break;
      }
    }
    if (h.length !== 0)
      if (h.length === 1) {
        const [d] = h;
        o[s] = d;
      } else
        o[s] = h.join(" ");
  }
  return console.log(o), o;
}
function Nt() {
  const e = document.querySelector(
    ".ant-formily-item-error"
  );
  if (!e) return;
  const t = e.querySelector(
    "input, textarea, .ant-select-selector"
  );
  t && (t.scrollIntoView({ behavior: "smooth", block: "center" }), t.focus());
}
const Rs = {
  ArrayTable: ve,
  "ArrayTable.Column": ve.Column,
  "ArrayTable.Addition": ve.Addition,
  "ArrayTable.Remove": ve.Remove,
  "ArrayTable.MoveUp": ve.MoveUp,
  "ArrayTable.MoveDown": ve.MoveDown,
  "ArrayTable.Index": ve.Index,
  Form: hr,
  FormItem: gr,
  FormGrid: yr,
  FormLayout: mr,
  Input: Xe,
  "Input.TextArea": Xe.TextArea,
  DatePicker: fr,
  Select: dr,
  Switch: ur,
  NumberPicker: lr,
  Checkbox: cr,
  Radio: ar,
  Cascader: sr,
  TreeSelect: or,
  TimePicker: ir,
  Password: rr,
  Upload: nr,
  Submit: Kt,
  Reset: zt
}, Es = {
  "MantineFormTab.TabPane": ln.TabPane,
  SectionTitle: Ps
}, Vs = (e, t, n) => async (r) => {
  var i;
  if (!((i = r.dataSource) != null && i.length))
    try {
      r.loading = !0;
      const o = ie(`/${e}/list?limit=500`), a = await re(o), s = Array.isArray(a) ? a : (a == null ? void 0 : a.data) ?? [];
      r.dataSource = s.map((c) => ({
        label: c[t],
        value: c[n]
      }));
    } catch (o) {
      console.error(`Failed to load options for ${e}:`, o), r.dataSource = [];
    } finally {
      r.loading = !1;
    }
}, $s = (e, t) => ((t == null ? void 0 : t.label) ?? "").toLowerCase().includes(e.toLowerCase()), pn = ({
  entity: e,
  formMode: t,
  formID: n,
  initialValues: r,
  pattern: i = "editable",
  showActions: o = !0,
  onFormReady: a,
  onSubmit: s,
  parentForm: c
}) => {
  var ce, me;
  const [f, g] = L(i), [h, d] = L(n), [b, S] = L(null), l = Yn(e), O = z((y) => y.profile), $ = z((y) => y.access), w = si(), Z = R(() => s ? !0 : t === "create" ? ti(e) : Xt(e), [s, t, e, $]), x = N(
    (y) => {
      var A;
      const m = ((A = y.path) == null ? void 0 : A.segments) ?? [], T = String(m[m.length - 1] ?? "");
      if (!T) return;
      if (i === "readPretty") {
        y.pattern = i;
        return;
      }
      if (y.disabled) {
        y.pattern = "readPretty";
        return;
      }
      const D = ri(
        e,
        T,
        t
      );
      y.pattern = D;
    },
    [e, t, i]
  ), I = U(/* @__PURE__ */ new Map()), K = R(
    () => ({
      register: (y, m) => {
        I.current.set(y, m);
      },
      unregister: (y) => {
        I.current.delete(y);
      }
    }),
    []
  ), [B, ue] = L(
    null
  ), P = !c && t !== "read", ne = R(
    () => Jn({
      parentEntity: w == null ? void 0 : w.parent,
      parentID: w == null ? void 0 : w.parentID,
      entity: e,
      formMode: t,
      formID: t === "create" ? void 0 : n ?? h
    }),
    [w == null ? void 0 : w.parent, w == null ? void 0 : w.parentID, e, t, n, h]
  ), X = U(P);
  Y(() => {
    var m;
    let y = !1;
    return t === "create" && (l != null && l.columns) && ((m = l == null ? void 0 : l.ui) != null && m.prefill) && (w != null && w.links) && Ds(
      l.columns,
      l.ui.prefill,
      w.links
    ).then((T) => {
      !y && Object.keys(T).length > 0 && ue(T);
    }), () => {
      y = !0;
    };
  }, [t, l == null ? void 0 : l.columns, (ce = l == null ? void 0 : l.ui) == null ? void 0 : ce.prefill, w == null ? void 0 : w.links]);
  const E = R(() => {
    var T;
    const y = /* @__PURE__ */ new Set(), m = (T = l == null ? void 0 : l.ui) == null ? void 0 : T.form;
    if (!m) return y;
    if (m.sections)
      for (const D of m.sections)
        for (const A of D.fields) y.add(A);
    else if (m.tabs) {
      for (const D of m.tabs)
        if (D.sections)
          for (const A of D.sections)
            for (const G of A.fields) y.add(G);
        else if (D.fields)
          for (const A of D.fields) y.add(A);
    }
    return y;
  }, [(me = l == null ? void 0 : l.ui) == null ? void 0 : me.form]), q = R(() => {
    var T;
    const y = b ?? r;
    let m = y != null ? { ...y } : void 0;
    if (t === "create" && (l != null && l.columns)) {
      const D = Zn(
        l.columns,
        O,
        E.size > 0 ? E : void 0
      );
      m = { ...m ?? {} };
      for (const [A, G] of Object.entries(D))
        (m[A] === void 0 || m[A] === null || m[A] === "") && (m[A] = G);
      if (B)
        for (const [A, G] of Object.entries(B))
          (m[A] === void 0 || m[A] === null || m[A] === "") && (m[A] = G);
      if (w != null && w.links)
        for (const [A, G] of Object.entries(w.links))
          for (const [Ae, j] of Object.entries(
            l.columns
          ))
            j.target === A && (m[Ae] = { id: G });
    } else if (l != null && l.columns) {
      m = { ...m ?? {} };
      for (const [D, A] of Object.entries(l.columns))
        !((T = A.ui) != null && T.virtual) || A.ui.default === void 0 || E.size > 0 && !E.has(D) || (m[D] === void 0 || m[D] === null || m[D] === "") && (m[D] = A.ui.default);
    }
    return m;
  }, [
    t,
    l == null ? void 0 : l.columns,
    r,
    O,
    b,
    w == null ? void 0 : w.links,
    B,
    E
  ]), v = R(() => {
    let y = q !== void 0 ? { ...q } : void 0;
    if (P) {
      const m = Wn(ne);
      m && (y = { ...y ?? {}, ...m });
    }
    return y;
  }, [q, P, ne]), F = R(
    () => br({
      initialValues: v,
      effects(y) {
        var G, Ae;
        const m = {
          form: y,
          formMode: t,
          editID: h,
          entity: e,
          parentForm: c
        }, T = /* @__PURE__ */ new Map(), D = i === "readPretty" || i === "readOnly" || i === "disabled", A = (j) => {
          if (!j) return [];
          const oe = Array.isArray(j) ? j : [j], ye = [];
          for (const se of oe) {
            const ke = typeof se == "string" ? se : se.name, gt = typeof se == "string" ? void 0 : se.props, M = vs(ke);
            M && ye.push({ handler: M, props: gt });
          }
          return ye;
        };
        for (const [j, oe] of Object.entries(
          (l == null ? void 0 : l.columns) ?? {}
        )) {
          const ye = D ? [] : A((G = oe.ui) == null ? void 0 : G.validate), se = A(
            (Ae = oe.ui) == null ? void 0 : Ae.transform
          );
          ye.length === 0 && se.length === 0 || T.set(j, {
            transforms: se,
            validators: ye
          });
        }
        for (const [
          j,
          { transforms: oe, validators: ye }
        ] of T) {
          const se = () => {
            (i === "readPretty" || i === "readOnly" || i === "disabled") && (y.setState((M) => {
              M.pattern = i;
            }), y.query("*").forEach((M) => {
              "setPattern" in M ? M.setPattern(i) : "pattern" in M && (M.pattern = i);
            }));
          }, ke = (M, ht) => {
            for (const { handler: Nn, props: bt } of ht) {
              const St = Nn(
                M,
                m,
                bt ? ws(bt, M) : void 0
              );
              if (St)
                return M.setSelfErrors([St]), !1;
            }
            return !0;
          };
          Sr(j, (M) => {
            if (!ke(M, oe)) {
              se();
              return;
            }
            if (!ke(M, ye)) {
              se();
              return;
            }
            M.setSelfErrors([]), se();
          }), Fr(j, (M) => {
            if (oe.length > 0 && ke(M, oe), "value" in M && M.value !== void 0 && M.value !== null && M.value !== "" && ye.length > 0) {
              if (!ke(M, ye)) {
                se();
                return;
              }
              M.setSelfErrors([]);
            }
            se();
          });
        }
        if (P) {
          let j = null;
          const oe = () => {
            X.current && Gn(ne, {
              ...y.values
            });
          };
          _r(() => {
            X.current && (j && clearTimeout(j), j = setTimeout(oe, 300));
          }), wr(() => {
            j && clearTimeout(j), oe();
          });
        }
      },
      pattern: i
    }),
    [
      e,
      v,
      t,
      h,
      i,
      c,
      l == null ? void 0 : l.columns,
      l == null ? void 0 : l.renderStatus,
      P,
      ne
    ]
  ), H = N(() => s || (t === "create" ? (y) => qn(e, y) : (y) => Ct(e, y, h)), [s, t, h, e]), W = U(null), [ge, he] = L(!1), we = N(() => {
    if (W.current)
      return W.current;
    const y = (async () => {
      if (F._tabsMounting)
        throw Ie.warning(
          "Please wait — form fields are still loading. Try again in a moment."
        ), new Error("TABS_STILL_MOUNTING");
      let m = {};
      try {
        for (const [
          D,
          A
        ] of I.current.entries()) {
          await A.validate();
          const G = A.getValues();
          F.setValuesIn(D, G);
        }
        F.queryFeedbacks({
          type: "error",
          code: "FormValidatorError"
        }).forEach(({ address: D }) => {
          if (!D) return;
          const A = F.query(D).take();
          A && "setFeedback" in A && A.setFeedback({
            type: "error",
            code: "FormValidatorError",
            messages: []
          });
        });
        const T = H();
        await F.submit(async (D) => {
          var Ae;
          const A = await Ns({
            form: F,
            values: D,
            entity: e,
            formMode: t,
            parentForm: c
          });
          if (!A.passed)
            throw new Error(A.message);
          const G = { ...A.values };
          if (l != null && l.columns)
            for (const [j, oe] of Object.entries(
              l.columns
            ))
              (oe.relation === "many-to-many" || ((Ae = oe.ui) == null ? void 0 : Ae.multiple) === !0) && G[j] === void 0 && (G[j] = []);
          if (E.size > 0) {
            for (const j of Object.keys(G))
              if (j !== "id" && !E.has(j)) {
                delete G[j];
                continue;
              }
          }
          m = await T(G), S(m), Ie.success("Form submitted successfully!"), d(m == null ? void 0 : m.id), P && (X.current = !1, wt(ne));
        });
      } catch (T) {
        throw Ie.error(
          T instanceof Error ? T.message : "Please review the missing or invalid fields and try again."
        ), Nt(), T;
      }
      return m;
    })();
    return W.current = y, he(!0), y.finally(() => {
      W.current === y && (W.current = null), he(!1);
    }), y;
  }, [
    F,
    H,
    e,
    t,
    E,
    P,
    ne,
    l == null ? void 0 : l.columns,
    c
  ]), Se = N(
    (y) => {
      F.setState((m) => {
        m.pattern = y;
      }), g(y);
    },
    [F]
  );
  Y(() => {
    Se(i);
  }, [i, Se]);
  const Te = f === "editable" && o && Z, Fe = !l || l.renderStatus === "pending", _ = (l == null ? void 0 : l.renderStatus) === "error", k = l == null ? void 0 : l.render, p = l == null ? void 0 : l.renderError, ee = R(
    () => pr({
      components: {
        ...Rs,
        ...To,
        ...As(),
        ...Es
      },
      scope: {
        loadAsyncDataSource: Vs,
        filterRelationOption: $s,
        resolveFieldAccess: x
      }
    }),
    [x]
  ), V = N(async () => {
    P && (X.current = !1, wt(ne));
    const y = q ? { ...q } : {};
    F.setInitialValues(y, "overwrite"), await F.reset("*", { forceClear: !0 }), F.setValues(y, "overwrite"), P && (X.current = !0);
  }, [F, P, ne, q]);
  return Y(() => {
    a == null || a({
      submit: we,
      setPattern: Se,
      reset: V,
      validate: () => F.validate(),
      getValues: () => F.values
    });
  }, [a, we, Se, F, V]), /* @__PURE__ */ u(Ir, { children: /* @__PURE__ */ C(Q, { className: `${kt.formContainer} formDrawTheme`, children: [
    Fe && /* @__PURE__ */ u(Oe, { tip: "Loading form schema..." }),
    _ && /* @__PURE__ */ u(
      Ye,
      {
        type: "error",
        title: "Failed to load form",
        description: p || "Unknown error occurred"
      }
    ),
    !Fe && !_ && !k && /* @__PURE__ */ u(
      Ye,
      {
        type: "warning",
        title: "No schema available",
        description: "The form schema could not be loaded."
      }
    ),
    !Fe && !_ && k && /* @__PURE__ */ C(Tr, { form: F, children: [
      /* @__PURE__ */ u(
        on.Provider,
        {
          value: K,
          children: /* @__PURE__ */ u(ee, { schema: k })
        }
      ),
      Te && /* @__PURE__ */ C(
        Q,
        {
          gap: 12,
          className: kt.formActions,
          align: "center",
          children: [
            /* @__PURE__ */ u(
              Kt,
              {
                type: "primary",
                onSubmit: we,
                onSubmitFailed: (y) => {
                  Ie.error(
                    `Please fill in all required fields ${y.map((m) => m.path).join(", ")}`
                  ), Nt();
                },
                className: "actionCardButton",
                icon: /* @__PURE__ */ u(Et, {}),
                loading: ge,
                disabled: ge,
                children: "Save"
              }
            ),
            /* @__PURE__ */ u(
              zt,
              {
                type: "primary",
                danger: !0,
                className: "actionCardButton",
                icon: /* @__PURE__ */ u(Vt, {}),
                onClick: () => {
                  V();
                },
                children: "Reset"
              }
            )
          ]
        }
      )
    ] })
  ] }) });
}, Tn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FormDraw: pn
}, Symbol.toStringTag, { value: "Module" })), yt = /* @__PURE__ */ new Map();
function Ga(e) {
  for (const [t, n] of Object.entries(e))
    yt.set(t, n);
}
function Ms(e) {
  return yt.get(e);
}
function Qa() {
  yt.clear();
}
const Bs = "_container_19b60_1", js = "_header_19b60_6", Ls = "_formBody_19b60_15", Us = "_actionBar_19b60_21", xs = "_actionBarZones_19b60_39", Hs = "_actionBarZone_19b60_39", Cs = "_actionBarZoneLeft_19b60_56", zs = "_actionBarZoneCenter_19b60_60", Ks = "_actionBarZoneRight_19b60_65", qs = "_formButton_19b60_69", Ys = "_readModeIcon_19b60_73", Js = "_readModeText_19b60_78", Zs = "_loadingWrap_19b60_85", te = {
  container: Bs,
  header: js,
  formBody: Ls,
  actionBar: Us,
  actionBarZones: xs,
  actionBarZone: Hs,
  actionBarZoneLeft: Cs,
  actionBarZoneCenter: zs,
  actionBarZoneRight: Ks,
  formButton: qs,
  readModeIcon: Ys,
  readModeText: Js,
  loadingWrap: Zs
}, kn = /* @__PURE__ */ new Set([
  "patient_case",
  "patient_pap",
  "patient_biosimilar_program",
  "patient_bridge_program",
  "patient_copay_program",
  "discount_drug_program"
]), Ws = 1500;
async function Gs(e, t) {
  await e.invalidateQueries({
    queryKey: [...Pe.entityRoot(t)]
  }), kn.has(t) && t !== "patient_case" && await e.invalidateQueries({
    queryKey: [...Pe.entityRoot("patient_case")]
  });
}
function Qs(e, t, n = Ws) {
  if (!kn.has(t))
    return () => {
    };
  const r = window.setTimeout(() => {
    e.invalidateQueries({
      queryKey: [...Pe.entityRoot("patient_case")]
    }), t !== "patient_case" && e.invalidateQueries({
      queryKey: [...Pe.entityRoot(t)]
    });
  }, n);
  return () => {
    window.clearTimeout(r);
  };
}
const It = ["edit", "cancel", "archive", "save"], Xa = ({
  entity: e,
  data: t,
  mode: n = "read",
  showEditButton: r = !0,
  onSubmit: i,
  onArchived: o,
  onClose: a,
  onSaved: s
}) => {
  const c = Mn(), f = Hn(), g = Qn(f.data[e]), h = Xt(e), d = ni(e), b = !g || !h, S = N(
    (p) => ii(
      e,
      Xn(p, g)
    ),
    [e, g]
  ), [l, O] = L(() => S(n)), [$, w] = L(!1), [Z, x] = L(!1), I = U(!1), [K, B] = L(null), ue = U(null), P = N(
    (p) => {
      O(S(p));
    },
    [S]
  );
  Y(() => {
    P(n);
  }, [n, P]);
  const [ne, X] = L(null), E = (t == null ? void 0 : t.id) ?? ne, q = U(t == null ? void 0 : t.id);
  Y(() => {
    const p = t == null ? void 0 : t.id;
    p == null || q.current === p || (q.current = p, X(null), P(n));
  }, [t == null ? void 0 : t.id, n, P]);
  const v = l === "create", F = l === "read", H = l === "edit" || l === "create", [
    {
      data: W,
      isLoading: ge,
      refetch: he
    }
  ] = Cn(e, E, {
    enabled: !v && E !== null
  }), we = R(() => v ? t : W != null && E !== null && String(W.id) === String(E) ? W : t ?? W, [v, t, W, E]), Se = N((p) => {
    B(p);
  }, []);
  Y(() => {
    ge && !W && B(null);
  }, [ge, W]);
  const Te = R(
    () => ({
      entityID: E,
      entity: e,
      mode: l,
      isReadMode: F
    }),
    [e, E, F, l]
  ), Fe = R(() => {
    var me;
    if (!K)
      return {};
    const p = {
      entity: e,
      entityID: E,
      formHandle: K,
      isCreateMode: v,
      isReadMode: F,
      mode: l,
      setViewMode: P
    }, ee = {
      edit: {
        onClick: async ({ formHandle: y }) => {
          b || (await he(), y.setPattern("editable"), P("edit"));
        },
        isVisible: () => F && r && !b,
        icon: /* @__PURE__ */ u($n, {}),
        label: "Edit",
        position: "right",
        type: "primary"
      },
      cancel: {
        onClick: async ({ formHandle: y }) => {
          try {
            await y.reset();
          } finally {
            v || (y.setPattern("readPretty"), P("read"));
          }
        },
        isVisible: () => !F,
        icon: /* @__PURE__ */ u(Vt, {}),
        label: v ? "Reset" : "Cancel",
        position: "left",
        type: "danger"
      },
      archive: {
        onClick: async ({ formHandle: y }) => {
          if (E !== null) {
            w(!0);
            try {
              if (await Ct(
                e,
                { archived: !0 },
                E
              ), await c.invalidateQueries({
                queryKey: [...Pe.entityRoot(e), "list"]
              }), e === "patient_case")
                for (const m of [
                  "patient_pap",
                  "patient_copay_program",
                  "discount_drug_program"
                ])
                  await c.invalidateQueries({
                    queryKey: [
                      ...Pe.entityRoot(m),
                      "list"
                    ]
                  });
              Ie.success("Record archived"), y.setPattern("readPretty"), o == null || o();
            } catch (m) {
              Ie.error(
                m instanceof Error ? m.message : "Failed to archive record"
              );
            } finally {
              w(!1);
            }
          }
        },
        isVisible: () => d && !F && !v && E !== null,
        icon: /* @__PURE__ */ u(Vn, {}),
        label: "Archive",
        position: "left",
        type: "secondary"
      },
      save: {
        onClick: async ({ formHandle: y }) => {
          var m;
          if (!I.current) {
            I.current = !0, x(!0);
            try {
              const T = l, D = await y.submit();
              X(D.id), y.setPattern("readPretty"), P("read"), await he(), await Gs(c, e), (m = ue.current) == null || m.call(ue), ue.current = Qs(
                c,
                e
              ), s == null || s(D, { mode: T });
            } catch (T) {
              console.error("Form submission error:", T);
            } finally {
              I.current = !1, x(!1);
            }
          }
        },
        isVisible: () => !F,
        icon: /* @__PURE__ */ u(Et, {}),
        label: v ? "Create" : "Save",
        position: "right",
        type: "primary"
      }
    }, V = Ms(e), ce = ((me = V == null ? void 0 : V.actionButtons) == null ? void 0 : me.call(V, p)) ?? {};
    return { ...ee, ...ce };
  }, [
    e,
    E,
    K,
    v,
    F,
    a,
    o,
    s,
    c,
    he,
    l,
    d,
    b,
    r,
    P
  ]), _ = R(() => {
    const p = (m) => {
      const T = It.indexOf(
        m
      );
      return T === -1 ? It.length : T;
    }, ee = Object.entries(Fe).filter(
      ([, m]) => m.isVisible()
    ), V = [], ce = [], me = [];
    for (const m of ee) {
      const T = m[1].position;
      T === "left" ? V.push(m) : T === "center" ? ce.push(m) : me.push(m);
    }
    const y = (m, T) => {
      const D = p(m), A = p(T);
      return D !== A ? D - A : m.localeCompare(T);
    };
    return V.sort(([m], [T]) => y(m, T)), ce.sort(([m], [T]) => y(m, T)), me.sort(([m], [T]) => y(m, T)), { center: ce, left: V, right: me };
  }, [Fe]), k = (p) => p.map(([ee, V]) => {
    const ce = V.type === "danger", me = V.type === "primary" || ce ? "primary" : void 0;
    return /* @__PURE__ */ u(
      pe,
      {
        type: me,
        danger: ce,
        loading: ee === "archive" ? $ : ee === "save" ? Z : void 0,
        disabled: ee === "save" && Z || ee === "archive" && $,
        onClick: () => {
          V.onClick({
            formHandle: K,
            ...Te
          });
        },
        icon: V.icon,
        className: te.formButton,
        children: V.label
      },
      ee
    );
  });
  return /* @__PURE__ */ C(rt, { children: [
    /* @__PURE__ */ C(Q, { vertical: !0, gap: 16, className: te.container, children: [
      /* @__PURE__ */ u(Q, { align: "center", className: te.header }),
      /* @__PURE__ */ u(Q, { vertical: !0, className: te.formBody, children: ge && !W ? /* @__PURE__ */ u(
        Q,
        {
          justify: "center",
          align: "center",
          className: te.loadingWrap,
          children: /* @__PURE__ */ u(Oe, { tip: "Loading entity data..." })
        }
      ) : /* @__PURE__ */ u(
        pn,
        {
          entity: e,
          formMode: l,
          formID: E ?? (t == null ? void 0 : t.id),
          initialValues: we,
          pattern: H ? "editable" : "readPretty",
          showActions: !1,
          onFormReady: Se,
          onSubmit: i
        },
        `form-draw-${e}-${l}-${E}-${l}`
      ) })
    ] }),
    /* @__PURE__ */ u(
      Q,
      {
        className: te.actionBar,
        justify: "space-between",
        align: "center",
        children: /* @__PURE__ */ C(Q, { className: te.actionBarZones, align: "center", flex: 1, children: [
          /* @__PURE__ */ C(
            Q,
            {
              className: `${te.actionBarZone} ${te.actionBarZoneLeft}`,
              gap: 12,
              align: "center",
              children: [
                F && /* @__PURE__ */ C(Q, { gap: 12, align: "center", children: [
                  /* @__PURE__ */ u(En, { className: te.readModeIcon }),
                  /* @__PURE__ */ u(
                    _e.Text,
                    {
                      className: te.readModeText,
                      children: "READ-ONLY MODE"
                    }
                  ),
                  a && /* @__PURE__ */ u(
                    pe,
                    {
                      onClick: a,
                      className: te.formButton,
                      children: "Close"
                    }
                  )
                ] }),
                k(_.left)
              ]
            }
          ),
          /* @__PURE__ */ u(
            Q,
            {
              className: `${te.actionBarZone} ${te.actionBarZoneCenter}`,
              gap: 12,
              align: "center",
              justify: "center",
              children: k(
                _.center
              )
            }
          ),
          /* @__PURE__ */ u(
            Q,
            {
              className: `${te.actionBarZone} ${te.actionBarZoneRight}`,
              gap: 12,
              align: "center",
              justify: "flex-end",
              children: k(
                _.right
              )
            }
          )
        ] })
      }
    )
  ] });
};
export {
  Gt as $,
  Da as A,
  Ra as B,
  Hr as C,
  Ea as D,
  ct as E,
  pn as F,
  lt as G,
  Zt as H,
  Va as I,
  xr as J,
  ii as K,
  oi as L,
  $a as M,
  Qr as N,
  Xr as O,
  ei as P,
  ti as Q,
  Ma as R,
  Xt as S,
  Kr as T,
  Ee as U,
  Gr as V,
  Wr as W,
  Zr as X,
  Cr as Y,
  Ze as Z,
  Wt as _,
  Ri as a,
  zr as a0,
  qr as a1,
  Yr as a2,
  Jr as a3,
  Ce as a4,
  Qt as a5,
  Ha as a6,
  en as a7,
  Ca as a8,
  fe as a9,
  Ba as aa,
  ja as ab,
  La as ac,
  ni as ad,
  Ua as ae,
  xa as af,
  ri as ag,
  Xa as b,
  ws as c,
  Ga as d,
  Qa as e,
  qa as f,
  Ms as g,
  Ya as h,
  vs as i,
  Ja as j,
  za as k,
  As as l,
  Ka as m,
  Za as n,
  Wa as o,
  Ns as p,
  pa as q,
  Ds as r,
  Ta as s,
  ka as t,
  si as u,
  Fs as v,
  Na as w,
  Ia as x,
  Oa as y,
  Pa as z
};
